
<div *ngIf="particiantJsonList.length==0"></div>
<div class="docWrapper">
    <div class="docCont">
      <div class="formtools">
        <mat-card class="toolHolder" *ngIf="isPageLoaded && !IsSigningComplete && !isReadOnlyGroupParticipant">       

            <ng-container *ngIf="!isDrawing">      
              <span class="" *ngIf="(!IsSigningComplete)">
                <button class="nextBtn aboveRes" color="warn"  mat-stroked-button (click)="movetoNextControl()">Move to next</button>
                <button class="nextIcon lowRes"  color="warn"  mat-icon-button  (click)="movetoNextControl()">
                  <mat-icon>arrow_forward_ios</mat-icon>
                </button>  
               
              </span>
            </ng-container>

            <div *ngIf="!isDrawing"  class="sepreator"></div>

            <button *ngIf="!isDrawing" id="fillFormsBtn"  mat-icon-button  matTooltipClass="tooltip" (click)="fillForms(fillForm)"  matTooltip="FILL FORM"><mat-icon>text_snippet</mat-icon></button>
            <div *ngIf="!isDrawing" class="sepreator"></div>
            <button *ngIf="!isDrawing"  mat-icon-button  matTooltipClass="tooltip" (click)="highlightRequiredControls()" matTooltip="VIEW REQURIED FIELDS"><mat-icon>verified</mat-icon></button>
            <div *ngIf="!isDrawing" class="sepreator"></div>
            <button  *ngIf="!isDrawing"  mat-icon-button matTooltipClass="tooltip" matTooltip="DRAW" (click)="drawonImg()"><mat-icon>edit</mat-icon></button>
           
            <div class="sepreator"></div>
            <button *ngIf="!isDrawing" class="actBtn"   mat-button [matMenuTriggerFor]="action">Actions <mat-icon >expand_more</mat-icon> </button>
            <mat-menu  #action="matMenu">
              <button mat-menu-item (click)="declineProject(decline)"><mat-icon>thumb_down_alt</mat-icon> Decline Form</button>             
              <button mat-menu-item (click)="clickTextField(true)" ><mat-icon>power_input</mat-icon> Add text field</button>
              <button mat-menu-item (click)="clickInitialsField(true)"><mat-icon>gesture</mat-icon> Add initials</button>
              <button mat-menu-item (click)="clickSignatureField(true)"><mat-icon>create</mat-icon> Add signature</button>
              <button mat-menu-item (click)="clearForm()"><mat-icon>format_clear</mat-icon> Clear Form</button>             
            </mat-menu>
           
            <button class="finish" color="primary" *ngIf="!isDrawing"  (click)="AcceptBtnClick(false)"   mat-flat-button >Save</button>
            <button class="finish" color="primary" *ngIf="!isDrawing" [attr.disabled]="IsSigningComplete"  (click)="SignatureAcceptance(acceptFinish,OtherFieldAssigned,requiredFieldAssigned)"   mat-flat-button >Finish </button>
            <button  *ngIf="isDrawing" class="finish" color="primary" (click)="drawonImg()" mat-icon-button>
              <mat-icon>check_circle_outline</mat-icon>
            </button>
            <div class="sepreator"></div>
            <button  *ngIf="isDrawing" class="finish" color="basic" (click)="Cleardrawing()" mat-icon-button>
              <mat-icon>highlight_off</mat-icon>
            </button>
            <button class="fileIcon" (click)="showAllFiles()"mat-icon-button ><mat-icon>insert_drive_file</mat-icon></button>
          </mat-card>
          <mat-card class="toolHolder" *ngIf="isPageLoaded && IsSigningComplete" >
            <div class="sepreator"></div><p>You have already finished the form.</p><div class="sepreator"></div>
          </mat-card>
          <mat-card class="toolHolder" *ngIf="isReadOnlyGroupParticipant" >
            <div class="sepreator"></div><p>You have read only permission.</p><div class="sepreator"></div>
          </mat-card>
    </div>

   
    <div class="docSign" id="docSign" #content >    
      
      <div class="FormResizer" >
      <div class="docHolding" [attr.style]="setPagePageStyle(i)? 'page-break-after: always;' : null"
       *ngFor="let item of particiantJsonList;let i= index;" id=docHolding{{i+1}}>
              
       <div class="iframe-drag-bounds" #dragBounds [ngStyle]= "{ 'width':imageWidth +'px', 'height':imageHeight+'px'}" >
        <app-canvas [height]="setHeight(i)" [width]="setWidth(i)"  [ngStyle]= "{ 'width':imageWidth +'px', 'height':imageHeight+'px'}" [canvasIndex]="i" (newItemEvent)="setIndex($event,selectedDocumentId)" *ngIf="isDrawing"></app-canvas>
       
        <ng-container *ngFor="let field of item.fields;let j= index;">
           
            <ng-container  *ngIf="field.fieldTypeName!=='Checkbox' && field.fieldTypeName!=='Radio'
            && field.fieldTypeName!=='CheckBoxGroup' && field.fieldTypeName!=='Image'">            
             <div  class="iframe-resize-container"
               [ngClass]="{'fileControl' :field.fieldTypeName=='Draw' || field.fieldTypeName=='Signature' || field.fieldTypeName=='Initials'  }"                
               [ngStyle]="{'position': 'absolute','width': field.offsetWidth+'px','height': field.offsetHeight+'px','transform': 'translate('+field.offsetX + 'px,'+ field.offsetY + 'px)'}"        
               [ngClass]="{'ng-show-required' : field.showRequiredControls}"  
               (click)="verifyParticipant(field,$event)"                
                >
               <div class="iframe-drag-handle" id="dh{{field.id}}"
                   (click)="addActiveClass(field)"

                    [ngStyle]="{'transform':'rotate('+field.rotation+'deg)'}"
                    [attr.field]="field.id" [attr.tabIndex]="setTabIndex(i,j)"                    
                      #dragHandle >
              
                      <ng-container *ngIf="field.fieldTypeName=='Textbox' && field.Control!='Static'">
                        <input [disabled]="field.isDisabled"  matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="field.isEditable==false" [maxlength]="field.charLimit"
                        [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                       ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px', 'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"  
                       [maxlength]="field.charLimit" (input)="onChange($event.target.value,item,field)"                         
                        [attr.value]="field.selectedValue"
                        type="text" [(ngModel)]='field.selectedValue'  id="{{field.id}}"
                        placeholder="{{field.fieldName}}"
                        [ngClass]="{'ng-active' : field.ShowtoolDetail}">
                    
                        <input [disabled]="field.isDisabled" matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="field.isEditable==true" [maxlength]="field.charLimit"
                        [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                       ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px', 'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"  
                       [maxlength]="field.charLimit" (input)="onChange($event.target.value,item,field)"                         
                        [attr.value]="field.selectedValue"
                        type="text" [(ngModel)]='field.selectedValue'  id="{{field.id}}"                       
                        [ngClass]="{'ng-active' : field.ShowtoolDetail}"   
                         >
                      </ng-container> 

                      <ng-container   *ngIf="field.fieldTypeName=='Textarea'">
                        <textarea matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" [disabled]="field.isDisabled" *ngIf="field.isEditable==false"
                              cdkTextareaAutosize
                              cdkAutosizeMinRows="1"
                              cdkAutosizeMaxRows="5"
                               [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                       ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px', 'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"  
                        [maxlength]="field.charLimit" [innerHTML]="field.selectedValue" [(ngModel)]='field.selectedValue'
                        
                          (input)="onChangeTexarea($event.target.value,item,field)"
                         (click)="OpentoolDetail('Textarea')" class="form-control"  id="{{field.id}}" placeholder="{{field.fieldName}}"
                         [ngClass]="{'ng-active' : field.ShowtoolDetail}" maxlength="field.charLimit"
                         (click)="OpentoolDetailText(item,field.id)"></textarea>
                        
                         <textarea matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" [disabled]="field.isDisabled"  *ngIf="field.isEditable==true" 
                         cdkTextareaAutosize
                         cdkAutosizeMinRows="1"
                         cdkAutosizeMaxRows="5"
                         [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                         ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px', 'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"  
                          [maxlength]="field.charLimit" [innerHTML]="field.selectedValue" [(ngModel)]='field.selectedValue'  (input)="onChangeTexarea($event.target.value,item,field)"
                           (click)="OpentoolDetail('Textarea')" class="form-control"  id="{{field.id}}" placeholder="{{field.fieldName}}"
                           [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                           (click)="OpentoolDetailText(item,field.id)"></textarea>
                       </ng-container>

                      <ng-container *ngIf="field.fieldTypeName=='Number'">
                        <input matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" [disabled]="field.isDisabled"  [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight,
                         'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                        ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px','border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')','transform':'rotate('+field.rotation+'deg)'}"  placeholder="{{field.fieldName}}"              
                        [(ngModel)]='field.selectedValue' [attr.value]="field.selectedValue" type="text" class="form-control"  id="{{field.id}}"
                        (input)="onChange($event.target.value,item,field)" (click)="OpentoolDetail('Number')" [maxlength]="field.charLimit"
                        (keypress)="numberOnly($event)"  id="{{field.id}}" (click)="OpentoolDetailText(item,field.id)"
                        [ngClass]="{'ng-active' : field.ShowtoolDetail}">
                      </ng-container>
                     
                      <ng-container *ngIf="field.fieldTypeName=='Address' && field.Control!='Static'">
                        <input [disabled]="field.isDisabled"  matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="field.isEditable==false" [maxlength]="field.charLimit"
                        [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                       ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px', 'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"  
                       [maxlength]="field.charLimit" (input)="onChange($event.target.value,item,field)"                         
                        [attr.value]="field.selectedValue"
                        type="text" [(ngModel)]='field.selectedValue'  id="{{field.id}}"
                        placeholder="{{field.fieldName}}"
                        [ngClass]="{'ng-active' : field.ShowtoolDetail}">
                    
                        <input [disabled]="field.isDisabled" matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="field.isEditable==true" [maxlength]="field.charLimit"
                        [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                       ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px', 'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"  
                       [maxlength]="field.charLimit" (input)="onChange($event.target.value,item,field)"                         
                        [attr.value]="field.selectedValue"
                        type="text" [(ngModel)]='field.selectedValue'  id="{{field.id}}"                       
                        [ngClass]="{'ng-active' : field.ShowtoolDetail}"   
                         >
                      </ng-container> 

                       <ng-container *ngIf="field.fieldTypeName=='City'">
                        <input matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" [disabled]="field.isDisabled" [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight,
                        'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                       ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px','border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')','transform':'rotate('+field.rotation+'deg)'}"  placeholder="{{field.fieldName}}" 
                        type="text" class="form-control"  id="{{field.id}}" placeholder="{{field.placeholder}}"
                        [(ngModel)]='field.selectedValue' [attr.value]="field.selectedValue"
                        [ngClass]="{'ng-active' : field.ShowtoolDetail}"                      
                        (input)="searchCity($event.target.value)" 
                        (input)="onChange($event.target.value,item,field)"
                        [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="cityselected($event,item,field.id)">
                          <mat-option *ngFor="let option of cityOption" [value]="option">
                            {{option}}
                          </mat-option>
                        </mat-autocomplete>
                       </ng-container>
                          
                       <ng-container *ngIf="field.fieldTypeName=='State'">
                         
                        <mat-select 
                        matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" 
                        matTooltipShowDelay="2500"
                         matTooltipClass="tooltip" 
                          id="{{field.id}}"  
                          [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                        ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px', 'line-height': field.offsetHeight+'px', 'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                        [disabled]="field.isDisabled"                        
                        (click)="OpentoolDetail('Dropdown')"
                        (click)="OpentoolDetailDropDown(item,field.id)"                     
                        (selectionChange)="setDdlValue($event,item,field)"  placeholder={{field.selectedValue}}
                          [(ngModel)]="field.selectedValue" [attr.value]="field.selectedValue"
                          [ngClass]="{'ng-active' : field.ShowtoolDetail}">
                          <mat-option>None</mat-option>
                          <mat-option [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'field-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                          ,'height': field.offsetHeight+'px'}"
                           *ngFor="let state of stateList" [value]="state">
                            {{ state }}
                          </mat-option>
                        </mat-select>            
                      </ng-container> 

                      <ng-container *ngIf="field.fieldTypeName=='Zip'">
                        <input matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" [disabled]="field.isDisabled" [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight,
                        'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                       ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px','border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')','transform':'rotate('+field.rotation+'deg)'}"  placeholder="{{field.fieldName}}" 
                        type="text" class="form-control"  id="{{field.id}}" placeholder="{{field.placeholder}}"
                        [(ngModel)]='field.selectedValue' [attr.value]="field.selectedValue"
                        [ngClass]="{'ng-active' : field.ShowtoolDetail}"                      
                        (input)="searchZip($event.target.value)" 
                        (input)="onChange($event.target.value,item,field)"
                        [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="zipselected($event,item,field.id)">
                          <mat-option *ngFor="let option of zipOption" [value]="option">
                            {{option}}
                          </mat-option>
                        </mat-autocomplete>
                       </ng-container>
                      
                      <ng-container *ngIf="field.fieldTypeName=='Dropdown'">
                       
                          <!-- <mat-label>Select {{field.placeholder}}</mat-label> -->

                        <mat-select 
                        matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" 
                        matTooltipShowDelay="2500" 
                        matTooltipClass="tooltip"  
                        id="{{field.id}}" 
                        [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                        ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px', 'line-height': field.offsetHeight+'px', 'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                        [disabled]="field.isDisabled"
                        (click)="OpentoolDetail('Dropdown')"
                        (click)="OpentoolDetailDropDown(item,field.id)"
                        (selectionChange)="setDdlValue($event,item,field)"  
                        placeholder={{field.selectedValue}}
                          [(ngModel)]="field.selectedValue" [attr.value]="field.selectedValue"
                          [ngClass]="{'ng-active' : field.ShowtoolDetail}">
                          <mat-option [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'field-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                          ,'height': field.offsetHeight+'px'}"
                           *ngFor="let drp of field.fillList" [value]="drp.val">
                            {{ drp.val }}
                          </mat-option>
                        </mat-select>     
                        <!-- </mat-form-field> -->
                      </ng-container>                   
                    
                      <ng-container *ngIf="field.fieldTypeName=='MultiSelect'">
                        <!-- <label>{{formatSubfolderName(field.subFolderName)}} {{field.fieldName}}</label> -->
                        <!-- <mat-form-field > -->
                          <!-- <mat-label>Select {{field.placeholder}}</mat-label> -->
                        <mat-select matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip"  id="{{field.id}}" [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily,'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                        color="primary"
                        [disabled]="field.isDisabled"
                        placeholder={{field.selectedValue}}
                        [ngModel]="field.selectedValue" 
                        (selectionChange)="setDdlValue($event,item,field)"
                        (click)="OpentoolDetail('MultiSelect')"
                        (click)="OpentoolDetailMulDropDown(item,field.id)" 
                        [ngClass]="{'ng-active' : field.ShowtoolDetail}"               
                         [required]='field.isRequired' multiple>
                        <mat-option *ngFor="let muldrp of field.fillList" [value]="muldrp.val">
                          {{ muldrp.val }}
                        </mat-option>
                         </mat-select>
                        <!-- </mat-form-field>-->
                       </ng-container>
                                     
                      <ng-container *ngIf="field.fieldTypeName=='Location'">
                           
                        <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="field.isDisabled" style="background-color:#dddddd;cursor: not-allowed; pointer-events: all !important;border: 2px solid rgba(118, 118, 118, 0.3)!important;" [class.disabled]="field.isDisabled"  id="{{field.id}}" class="customUpdate"
                        (click)="OpentoolDetail('Location')" (click)="fetchLocation(item,field.id)"
                        [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                        >
                          <span id="loc_Icon" *ngIf='!field.Lat && !field.Long'>
                            <mat-icon>location_on</mat-icon>
                            Location
                          </span>
                          <ng-container  *ngIf='field.Lat && field.Long'>
                          <h3 [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily}"  > 
                            Lat : {{field.Lat}}
                            Long: {{field.Long}}
                          </h3>
                         </ng-container>
                                      
                        </div>      
                        <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="!field.isDisabled"  [class.disabled]="field.isDisabled"  id="{{field.id}}" class="customUpdate"
                        (click)="OpentoolDetail('Location')" (click)="fetchLocation(item,field.id)"
                        [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                        [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}">
                          <span id="loc_Icon" *ngIf='!field.Lat && !field.Long'>
                            <mat-icon>location_on</mat-icon>
                            Location
                          </span>
                          <ng-container  *ngIf='field.Lat && field.Long'>
                          <h3 [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily}"  > 
                            Lat : {{field.Lat}}
                            Long: {{field.Long}}
                          </h3>
                         </ng-container>
                                      
                        </div>             
                       </ng-container>  
        
                       <ng-container *ngIf="field.fieldTypeName=='Date'">
                         <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" class="Dtime"  *ngIf="field.isDisabled" style="background-color:#dddddd;cursor: not-allowed; pointer-events: all !important;border: 2px solid rgba(118, 118, 118, 0.3)!important;"  [ngClass]="{'ng-active' : field.ShowtoolDetail}"                      
                         >

                          <input  [disabled]="field.isDisabled"  id="{{field.id}}" matInput type="text" [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 
                         'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily}"  
                          [attr.Value]="field.selectedValue |date:'yyyy-MM-dd'" placeholder="{{field.fieldName}}"   readonly
                          [ngModel]="field.selectedValue |date:'yyyy-MM-dd'"                     
                          (input)="onChange($event.target.value,item,field)"
                          (dateChange)="onChange($event.target.value,item,field)"
                          (click)="OpentoolDetail('Date')"
                          (click)="OpentoolDetailText(item,field.id)"  
                         [matDatepicker]="basicDatepicker"/>     

                       <mat-datepicker-toggle   matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
                       <mat-datepicker #basicDatepicker  ></mat-datepicker>  
                   
                         </div>

                         <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" class="Dtime"  *ngIf="!field.isDisabled"  [ngClass]="{'ng-active' : field.ShowtoolDetail}"                      
                         [ngStyle]="{'border': '2px solid rgb(' +convertRBA2RGB(field.colorCode) + ')'}">

                          <input  [disabled]="field.isDisabled"  id="{{field.id}}" matInput type="text" [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 
                         'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily}"  
                          [attr.Value]="field.selectedValue |date:'yyyy-MM-dd'" placeholder="{{field.fieldName}}"   readonly
                          [ngModel]="field.selectedValue |date:'yyyy-MM-dd'"                     
                          (input)="onChange($event.target.value,item,field)"
                          (dateChange)="onChange($event.target.value,item,field)"
                          (click)="OpentoolDetail('Date')"
                          (click)="OpentoolDetailText(item,field.id)"  
                         [matDatepicker]="basicDatepicker"/>     

                       <mat-datepicker-toggle   matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
                       <mat-datepicker #basicDatepicker  ></mat-datepicker>  
                   
                         </div>
                                     
                       </ng-container>
                       
                       <ng-container *ngIf="field.fieldTypeName=='Time'">
                        <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="field.isDisabled" style="background-color:#dddddd;cursor: not-allowed; pointer-events: all !important;border: 2px solid rgba(118, 118, 118, 0.3)!important;"  class="Dtime" [ngClass]="{'ng-active' : field.ShowtoolDetail}"                
                        >
                          <input [disabled]="field.isDisabled" id="{{field.id}}" type="text" [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                          aria-label="default time" [ngxTimepicker]="toggleTimepicker" (click)="OpentoolDetail('Time')" 
                          (click)="OpentoolDetailText(item,field.id)" matInput  placeholder="{{field.fieldName}}" [(ngModel)]='field.selectedValue' [attr.Value]='field.selectedValue' readonly>
                        <ngx-material-timepicker-toggle matSuffix [for]="toggleTimepicker"></ngx-material-timepicker-toggle>
                        <ngx-material-timepicker (timeSet)="onChange($event,item,field)"  #toggleTimepicker>
                        </ngx-material-timepicker>
                        </div>
                        <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="!field.isDisabled"  class="Dtime" [ngClass]="{'ng-active' : field.ShowtoolDetail}"                
                        [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}">
                          <input [disabled]="field.isDisabled" id="{{field.id}}" type="text" [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                          aria-label="default time" [ngxTimepicker]="toggleTimepicker" (click)="OpentoolDetail('Time')" 
                          (click)="OpentoolDetailText(item,field.id)" matInput  placeholder="{{field.fieldName}}" [(ngModel)]='field.selectedValue' [attr.Value]='field.selectedValue' readonly>
                        <ngx-material-timepicker-toggle matSuffix [for]="toggleTimepicker"></ngx-material-timepicker-toggle>
                        <ngx-material-timepicker (timeSet)="onChange($event,item,field)"  #toggleTimepicker>
                        </ngx-material-timepicker>
                        </div>
                       </ng-container>        
                      
                       <ng-container *ngIf="field.fieldTypeName=='File'">
                        <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="field.isDisabled" style="background-color:#dddddd;cursor: not-allowed; pointer-events: all !important;border: 2px solid rgba(118, 118, 118, 0.3)!important;"  [class.disabled]="field.isDisabled" class="customUpdate" (click)="OpentoolDetail('File')"  id="{{field.id}}"
                        (click)="OpentoolDetailText(item,field.id)" [ngClass]="{'ng-active' : field.ShowtoolDetail}" 
                        >
                          <span id="cloud_upload" *ngIf='field.FileData.length==0' style="cursor: not-allowed; pointer-events: all !important;">
                            <mat-icon>cloud_upload</mat-icon>
                            Upload File 
                          </span>                    
        
                          <div *ngFor="let file of field.FileData" class="uploadedData" style="cursor: not-allowed; pointer-events: all !important;">        
                            <p>{{file.FullPath}}</p>
                        </div>
                         <input type="file" class="form-control" id="{{field.fieldName}}" 
                         (change)="onSelectFile($event,item,field.id)" placeholder="{{field.fieldName}}">
                        </div>
                        <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="!field.isDisabled"  [class.disabled]="field.isDisabled" class="customUpdate" (click)="OpentoolDetail('File')"  id="{{field.id}}"
                        (click)="OpentoolDetailText(item,field.id)" [ngClass]="{'ng-active' : field.ShowtoolDetail}" 
                        [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}">
                          <span id="cloud_upload" *ngIf='field.FileData.length==0'>
                            <mat-icon>cloud_upload</mat-icon>
                            Upload File 
                          </span>                    
        
                          <div *ngFor="let file of field.FileData" class="uploadedData">        
                            <p>{{file.FullPath}}</p>
                        </div>
                         <input type="file" class="form-control" id="{{field.fieldName}}" 
                         (change)="onSelectFile($event,item,field.id)" placeholder="{{field.fieldName}}">
                        </div>
                      </ng-container>             
                        
                       <ng-container *ngIf="field.fieldTypeName=='Signature' && field.Control!='Static'">
                        <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500"
                         matTooltipClass="tooltip" *ngIf="field.isDisabled" 
                         
                         [class.disabled]="field.isDisabled" id="{{field.id}}"  
                         class="customUpdate"
                         [ngClass]="{'ng-active' : field.ShowtoolDetail}">
                          <span id="border_color" *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0' style="cursor: not-allowed; pointer-events: all !important;">
                            <mat-icon>border_color</mat-icon>
                            Signature
                          </span>
                           <!-- Signature Stamp-->
                           <div class="sig-cell" *ngIf='field.signatureBase64 || field.signatureText && !field.signatureBase64 || field.ImageData.length>0' [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                            <div class="sig-chrome" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                              <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics</div>
                              <div class="sig-container" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                                <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" />
                                <ng-container *ngIf='field.signatureText && !field.signatureBase64'>
                                  <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}">{{field.signatureText}}</h3>
                                </ng-container>

                                <div *ngFor="let img of field.ImageData" class="uploadedData" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" >
                                  <img [src]="img.Imageurl" />
                                </div>

                              </div>
                              <div class="sig-chrome-title-bottom ng-binding">{{field.participantEmailId}}</div>
                              <!-- <div class="sig-chrome-title-bottom ng-binding">{{participantEmailId}}</div> -->
                            </div>
                          </div>
                          <!-- Signature Stamp-->
                          <!-- <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" /> 
                         
                          <ng-container  *ngIf='field.signatureText && !field.signatureBase64'>
                          <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}" >{{field.signatureText}}</h3>
                         </ng-container>
                          <div *ngFor="let img of field.ImageData" class="uploadedData">
                            <img [src]="img.Imageurl"  [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}"/> 
                         </div>  -->
                        </div>     

                        <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" 
                         matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="!field.isDisabled" [class.disabled]="field.isDisabled" id="{{field.id}}"
                         class="customUpdate" 
                         [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                         [ngClass]="{'ng-active' : field.ShowtoolDetail,'bnone' : field.signatureBase64 || field.signatureText && !field.signatureBase64 || field.ImageData.length>0 }"
                         (click)="OpenSignPopup(AddSignature,item,field)">
                          <span id="border_color" *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0'>
                            <mat-icon>border_color</mat-icon>
                            Signature
                          </span>

                          <!-- Signature Stamp-->
                          <div class="sig-cell" *ngIf='field.signatureBase64 || field.signatureText && !field.signatureBase64 || field.ImageData.length>0' [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                            <div class="sig-chrome" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                              <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics</div>
                              <div class="sig-container" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" >
                                <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" />
                                <ng-container *ngIf='field.signatureText && !field.signatureBase64'>
                                  <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}">{{field.signatureText}}</h3>
                                </ng-container>

                                <div *ngFor="let img of field.ImageData" class="uploadedData" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" >
                                  <img [src]="img.Imageurl" />
                                </div>

                              </div>
                              <!-- <div class="sig-chrome-title-bottom ng-binding">{{participantEmailId}}</div> -->
                              <div class="sig-chrome-title-bottom ng-binding">{{field.participantEmailId}}</div>
                            </div>
                          </div>
                          <!-- Signature Stamp-->


                          <!-- <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" /> 
                         
                          <ng-container  *ngIf='field.signatureText && !field.signatureBase64'>
                          <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}" >{{field.signatureText}}</h3>
                         </ng-container>
                          <div *ngFor="let img of field.ImageData" class="uploadedData">
                            <img [src]="img.Imageurl"  [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}"/> 
                         </div> 
                          -->
                         

                        </div>                   
                       </ng-container>  
                       
                       <ng-container *ngIf="field.fieldTypeName=='Initials' && field.Control!='Static'">
                        <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500"
                         matTooltipClass="tooltip" *ngIf="field.isDisabled" 
                         
                         [class.disabled]="field.isDisabled" id="{{field.id}}"  
                         class="customUpdate"
                         [ngClass]="{'ng-active' : field.ShowtoolDetail}">
                          <span id="initial_gesture" *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0' style="cursor: not-allowed; pointer-events: all !important;">
                            <mat-icon>gesture</mat-icon>
                            Initials
                          </span>
                           <!-- Initials Stamp-->
                           <div class="sig-cell" *ngIf='field.signatureBase64 || field.signatureText && !field.signatureBase64 || field.ImageData.length>0' [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                            <div class="sig-chrome" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                              <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics</div>
                              <div class="sig-container">
                                <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" />
                                <ng-container *ngIf='field.signatureText && !field.signatureBase64'>
                                  <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}">{{field.signatureText}}</h3>
                                </ng-container>

                                <div *ngFor="let img of field.ImageData" class="uploadedData" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" >
                                  <img [src]="img.Imageurl"/>
                                </div>

                              </div>
                              <div class="sig-chrome-title-bottom ng-binding">{{field.participantEmailId}}</div>                             
                            </div>
                          </div>
                          <!-- Initials Stamp-->
                         
                        </div>     

                        <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" 
                         matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="!field.isDisabled" [class.disabled]="field.isDisabled" id="{{field.id}}"
                         class="customUpdate" 
                         [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                         [ngClass]="{'ng-active' : field.ShowtoolDetail,'bnone' : field.signatureBase64 || field.signatureText && !field.signatureBase64 || field.ImageData.length>0 }"
                         (click)="OpenSignPopup(AddInitial,item,field)">
                          <span id="initial_gesture" *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0'>
                            <mat-icon>gesture</mat-icon>
                            Initials
                          </span>

                          <!-- Initials Stamp-->
                          <div class="sig-cell" *ngIf='field.signatureBase64 || field.signatureText && !field.signatureBase64 || field.ImageData.length>0' [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                            <div class="sig-chrome" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                              <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics</div>
                              <div class="sig-container">
                                <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" />
                                <ng-container *ngIf='field.signatureText && !field.signatureBase64'>
                                  <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}">{{field.signatureText}}</h3>
                                </ng-container>

                                <div *ngFor="let img of field.ImageData" class="uploadedData" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" >
                                  <img [src]="img.Imageurl"/>
                                </div>

                              </div>                             
                              <div class="sig-chrome-title-bottom ng-binding">{{field.participantEmailId}}</div>
                            </div>
                          </div>
                          <!-- Initials Stamp-->                       

                        </div>                   
                       </ng-container>  

                       <ng-container *ngIf="field.fieldTypeName=='Draw'">
                        <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="field.isDisabled" style="background-color:#dddddd;cursor: not-allowed; pointer-events: all !important;border: 2px solid rgba(118, 118, 118, 0.3)!important;" [class.disabled]="field.isDisabled"  id="{{field.id}}" class="customUpdate" (click)="OpentoolDetail('Draw')" 
                        (click)="OpenDrawPopup(Draw,item,field,field.id)"
                        
                        [ngClass]="{'ng-active' : field.ShowtoolDetail}">
                          <span id="draw_brush" *ngIf='!field.drawBase64  && field.ImageData.length==0' style="cursor: not-allowed; pointer-events: all !important;">
                            <mat-icon>brush</mat-icon>
                            Draw 
                          </span>                                  
                          <img *ngIf='field.drawBase64' [src]="field.drawBase64"  [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}"/>  
                        </div>  
                        <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="!field.isDisabled" [class.disabled]="field.isDisabled"  id="{{field.id}}" class="customUpdate" (click)="OpentoolDetail('Draw')" 
                        (click)="OpenDrawPopup(Draw,item,field,field.id)"
                        [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                        [ngClass]="{'ng-active' : field.ShowtoolDetail}">
                          <span id="draw_brush" *ngIf='!field.drawBase64  && field.ImageData.length==0'>
                            <mat-icon>brush</mat-icon>
                            Draw 
                          </span>                                  
                          <img *ngIf='field.drawBase64' [src]="field.drawBase64"  [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}"/>  
                        </div>                 
                       </ng-container>  
        
                       <ng-container *ngIf="field.fieldTypeName=='Drawpopup'">
                        <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="!field.isDisabled"  [class.disabled]="field.isDisabled"  id="{{field.id}}" class="customUpdate" (click)="OpentoolDetail('Draw1')" (click)="OpenDrawInPopup(DrawInPopup)" >
                          <span id="draw_brush" *ngIf='!field.drawBase64  && field.ImageData.length==0'>
                            <mat-icon>brush</mat-icon>
                            Draw
                          </span>                                  
                          <img *ngIf='field.drawBase64' [src]="field.drawBase64" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}"/>  
                        </div>    
                        <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="field.isDisabled" style="background-color:#dddddd;cursor: not-allowed; pointer-events: all !important;border: 2px solid rgba(118, 118, 118, 0.3)!important;"  [class.disabled]="field.isDisabled"  id="{{field.id}}" class="customUpdate" (click)="OpentoolDetail('Draw1')" (click)="OpenDrawInPopup(DrawInPopup)" >
                          <span id="draw_brush" *ngIf='!field.drawBase64  && field.ImageData.length==0'>
                            <mat-icon>brush</mat-icon>
                            Draw
                          </span>                                  
                          <img *ngIf='field.drawBase64' [src]="field.drawBase64" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}"/>  
                        </div>                
                       </ng-container>                    
                              
                       <ng-container *ngIf="field.fieldTypeName=='BulletList'">
                         <label matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip"  id="{{field.id}}" class="bullet"  (click)="OpentoolDetail('BulletList')"
                          (click)="OpentoolDetailBulletList(item,field.id)"
                          [ngClass]="{'ng-active' : field.ShowtoolDetail}">
                           <ul (click)="OpentoolDetailBulletList(item,field.id)">
                             <li [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                             *ngFor="let bu of field.fillList">{{bu.val}}</li>
                           </ul>
                         </label>
                       </ng-container>
                       
                       <ng-container *ngIf="field.fieldTypeName=='Button'">
                        <a matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                        class="btn-primary btnGlobal"  id="{{field.id}}"
                        href="{{field.buttonURL}}" target="_blank"
                        (click)="OpentoolDetail('Button')" 
                        (click)="OpentoolDetailText(item,field.id)">{{field.buttonName}}</a>
                       </ng-container>        
                      
                       <ng-container *ngIf="field.fieldTypeName=='Table'">
                         <table matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="field.isDisabled" style="background-color:#dddddd;cursor: not-allowed; pointer-events: all !important;border: 2px solid rgba(118, 118, 118, 0.3)!important;" [class.disabled]="field.isDisabled"  id="{{field.id}}" class="formTable" border="1px" (click)="OpentoolDetail('Table')"
                         (click)="OpentoolDetailText(item,field.id)" [ngClass]="{'ng-active' : field.ShowtoolDetail}" >                   
                          <tbody (click)="OpentoolDetailtbl(item,field.id)">    
                          <tr *ngFor = "let row of field.rows;let r=index">
                            <td *ngFor = "let column of field.column;let c=index">
                              <input [disabled]="field.isDisabled" [attr.value]="getColumnValue(item,field.id,r+1,c+1)"  id='txt-{{r+1}}{{c+1}}' [ngModel]="getColumnValue(item,field.id,r+1,c+1)" (input)="onTableChange($event,item,field.id)"  type="text"/>
                            </td>
                           </tr>
                            </tbody>
                          </table>      
                          <table matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="!field.isDisabled" [class.disabled]="field.isDisabled"  id="{{field.id}}" class="formTable" border="1px" (click)="OpentoolDetail('Table')"
                         (click)="OpentoolDetailText(item,field.id)" [ngClass]="{'ng-active' : field.ShowtoolDetail}" >                   
                          <tbody (click)="OpentoolDetailtbl(item,field.id)">    
                          <tr *ngFor = "let row of field.rows;let r=index">
                            <td *ngFor = "let column of field.column;let c=index">
                              <input [disabled]="field.isDisabled" [attr.value]="getColumnValue(item,field.id,r+1,c+1)"  id='txt-{{r+1}}{{c+1}}' [ngModel]="getColumnValue(item,field.id,r+1,c+1)" (input)="onTableChange($event,item,field.id)"  type="text"/>
                            </td>
                           </tr>
                            </tbody>
                          </table>                 
                       </ng-container>
        
                       <ng-container *ngIf="field.fieldTypeName=='StrikeThrough'">
                        <div  id="{{field.id}}" style="border-top: 1px solid black; width: 100%;height: 20px; margin-top:18px"
                        (click)="OpentoolDetail('StrikeThrough')"
                        (click)="OpentoolDetailText(item,field.id)"></div>                  
                       </ng-container>
        
                       <ng-container *ngIf="field.fieldTypeName=='WhiteOut'">
                        <div  id="{{field.id}}" style="background-color: white; width: 100%;height: 100%;"
                         (click)="OpentoolDetail('WhiteOut')"
                         (click)="OpentoolDetailText(item,field.id)"></div>                  
                       </ng-container>                     
        
                       <ng-container *ngIf="field.fieldTypeName=='HighLight'">
                          <div style=" width: 100%;height: 100%;"  id="{{field.id}}"
                          [ngStyle]="{'background-color': 'rgba(' + field.backgroundColor + ')'}"
                           (click)="OpentoolDetail('HighLight')"
                           (click)="OpentoolDetailText(item,field.id)"></div>                  
                       </ng-container>
        
                        <ng-container *ngIf="field.fieldTypeName=='StraightLine'">
                            <div  id="{{field.id}}" style="border-bottom: 1px solid black; width: 100%;height: 20px; margin-top:0px"
                            (click)="OpentoolDetail('line')"
                            (click)="OpentoolDetailText(item,field.id)"></div>                  
                        </ng-container>
                      
                        <ng-container *ngIf="field.fieldTypeName=='measure'">
                          <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" [class.disabled]="field.isDisabled"  id="{{field.id}}" style="border-bottom: 1px solid black; width: 100%; margin:0px"
                          (click)="OpentoolDetail('measure')"
                          (click)="OpentoolDetailText(item,field.id)">
                           {{field?.width}}
                        </div>                  
                        </ng-container>
        
             </div>
           </div>
            </ng-container>

            <ng-container  *ngIf="field.fieldTypeName=='Checkbox' || field.fieldTypeName=='Radio' ||
         field.fieldTypeName=='CheckBoxGroup'">
          <div class="radioHolder"  id="{{field.id}}">
            <div *ngFor="let ele of field.fillList; let i=index"  class="iframe-resize-container"  [attr.field]="field.id"
            [ngStyle]="{'position': 'absolute','transform': 'translate('+ele.offsetX + 'px,'+ ele.offsetY + 'px)'}" 
            [ngClass]="{'ng-show-required' : field.showRequiredControls}"
            
            (click)="verifyParticipant(field,$event)">
            <div class="iframe-drag-handle" id="dh{{field.id}}"  [attr.field]="field.id"  (click)="addActiveClass(field)"
            [ngStyle]="{'border-color': 'rgba(' + field.colorCode + ')','height': field.offsetHeight+'px'}"
            #dragHandle [attr.tabIndex]="setTabIndex(i,j)">
            <ng-container *ngIf="field.fieldTypeName=='Checkbox'">
              <label  [ngClass]="{'ng-active' : field.ShowtoolDetail}"
              [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign,'display':'flex','align-items':'center', 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
               class="checkboxfield" (click)="OpentoolDetail('Checkbox')"
              (click)="OpentoolDetailCheckBox(item,field.id,ele.id)">                
                  <input matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" [disabled]="field.isDisabled" type="checkbox" class="mat-checkbox-input" [attr.checked]="ifChkChecked(field.id,item,ele.id)? 'checked' : null"  [checked]='ifChkChecked(field.id,item,ele.id)'
                    (click)="OnChangeCheckBox($event, ele.val, field,item,ele.id)"
                    [ngStyle]="{'width': field.offsetWidth+'px','height': field.offsetHeight+'px'}">
                   {{ele.val}}               
              </label>
            </ng-container>

            <ng-container *ngIf="field.fieldTypeName=='Radio'">
             <div class="flexCol"  id="{{field.id}}"> 
               <label   [ngClass]="{'ng-active' : field.ShowtoolDetail}"
               [ngStyle]="{'color': field.fontColor,'display':'flex','align-items':'center', 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
               class="radiofield" (click)="OpentoolDetail('Radio')"
               (click)="OpentoolDetailRadioButtonGroup(item,field.id,ele.id)">                
                 <input matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" [disabled]="field.isDisabled" type="radio" class="mat-checkbox-input" 
                 [ngStyle]="{'width': field.offsetWidth+'px','height': field.offsetHeight+'px'}"
                 [attr.Checked]="ifRadioChecked(field.id,item,ele.id)? 'checked' : null"  
                 name='{{field.id}}' [checked]='ifRadioChecked(field.id,item,ele.id)' [value]="ele.val" (change)="OnChangeRadio($event, ele.val, field.id,item,ele.id)" >
                 {{ele.val}}
               </label>                 
             
             </div>
            </ng-container>

            <ng-container *ngIf="field.fieldTypeName=='CheckBoxGroup'">
              <div class="flexCol"  id="{{field.id}}">
               <label  [ngClass]="{'ng-active' : field.ShowtoolDetail}"
               [ngStyle]="{'color': field.fontColor ,'display':'flex','align-items':'center','text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
               class="checkboxfield" (click)="OpentoolDetail('CheckBoxGroup')"
               (click)="OpentoolDetailCheckBoxGroup(item,field.id,ele.id)">                   
                
                 <input matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" [disabled]="field.isDisabled" class="mat-checkbox-input" type="checkbox"
                 [ngStyle]="{'width': field.offsetWidth+'px','height': field.offsetHeight+'px'}"
                  [attr.checked]="ifChkChecked(field.id,item,ele.id)? 'checked' : null" [checked]='ifChkChecked(field.id,item,ele.id)' (change)="OnChangeCheckBoxGroup($event, ele.val, field.id,item,ele.id)">
                 {{ele.val}}
               </label>               
              </div>
            </ng-container>

          </div>
        </div>
        </div>
            </ng-container>


            <ng-container  *ngIf="field.fieldTypeName=='Image'">
            <div class="radioHolder"  id="{{field.id}}">
            <div *ngFor="let ele of field.fillList; let i=index"  class="iframe-resize-container"  [attr.field]="field.id"
            [ngClass]="{'fileControl' :field.fieldTypeName=='Image'}" 
            [ngStyle]="{'height': field.Imageheight, 'width': field.Imagewidth,'transform': 'translate('+field.offsetX + 'px,'+ field.offsetY + 'px)'}" 
            style="position: absolute"  
            (click)="verifyParticipant(field,$event)">

          <div class="iframe-drag-handle" id="dh{{field.id}}" (click)="addActiveClass(field)"  [attr.field]="field.id" 
          [attr.tabIndex]="setTabIndex(i,j)"  
          #dragHandle>
 
          <ng-container *ngIf="field.fieldTypeName=='Image'">
            <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="field.isDisabled" style="background-color:#dddddd;cursor: not-allowed; pointer-events: all !important;border: 2px solid rgba(118, 118, 118, 0.3)!important;"  class="customUpdate" [class.disabled]="field.isDisabled" (click)="OpentoolDetail('Image')"  id="{{field.id}}"
            (click)="OpentoolDetailText(item,field.id)"
            
            [ngClass]="{'ng-active' : field.ShowtoolDetail}"
            [ngClass]="{'ng-show-required' : field.showRequiredControls}">
              <span id="cloud_upload" *ngIf='field.ImageData.length==0' style="cursor: not-allowed; pointer-events: all !important;">
                <mat-icon>cloud_upload</mat-icon>
                Upload Image
              </span>
              <div *ngFor="let img of field.ImageData" class="uploadedData">
                <img *ngIf='img.Imageurl' [src]="img.Imageurl" [ngStyle]="{'height': field.Imageheight, 'width': field.Imagewidth}"/> 
             </div>                  
                              
             <input type="file" class="form-control" accept="image/*" id="{{field.fieldName}}" 
             (change)="onSelectImage($event,item,field.id)" placeholder="{{field.fieldName}}">
            </div>         
            
            <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="!field.isDisabled"  class="customUpdate" [class.disabled]="field.isDisabled" (click)="OpentoolDetail('Image')"  id="{{field.id}}"
            (click)="OpentoolDetailText(item,field.id)"
            [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
            
            [ngClass]="{'ng-active' : field.ShowtoolDetail}"
            [ngClass]="{'ng-show-required' : field.showRequiredControls}">
              <span id="cloud_upload" *ngIf='field.ImageData.length==0'>
                <mat-icon>cloud_upload</mat-icon>
                Upload Image
              </span>
              <div *ngFor="let img of field.ImageData" class="uploadedData">
                <img *ngIf='img.Imageurl' [src]="img.Imageurl" [ngStyle]="{'height': field.Imageheight, 'width': field.Imagewidth}"/> 
             </div>                  
                              
             <input type="file" class="form-control" accept="image/*" id="{{field.fieldName}}" 
             (change)="onSelectImage($event,item,field.id)" placeholder="{{field.fieldName}}">
            </div>     
           </ng-container> 
 
           
               </div>
             </div>
           </div>
            </ng-container>

         
            <ng-container  *ngIf="field.fieldTypeName=='Textbox' && field.Control=='Static'">
             <div  [ngClass]="{'disableDiv': isPageLoaded && IsSigningComplete}" class="iframe-resize-container"
             [position]="{x: field.offsetX, y:field.offsetY}" 
             style="position: absolute;" [ngResizable]="!field.isDisabled" 
             [ngStyle]="{'position': 'absolute','width': field.offsetWidth+'px','height': field.offsetHeight+'px'}"                
             rzHandles="n,s,e,w,se,sw" [ngDraggable]="!field.isDisabled" [handle]="dragHandle"   
             (stopped)="onStop($event)" (movingOffset)="onMoving($event,item)"
             (endOffset)="onMoveEnd($event,item,field,'')"
             (rzStop)="onResizeStop($event,item,field.id)"
             [inBounds]="true">

            
             <!-- [bounds]="dragBounds" -->
             <!-- [appDisable]="field.isDisabled" -->
             
               <div class="iframe-drag-handle" id="dh{{field.id}}"                
                  [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                  [ngStyle]="{'transform':'rotate('+field.rotation+'deg)'}"                   
                  #dragHandle>

                      <ng-container *ngIf="field.fieldTypeName=='Textbox' && field.Control=='Static'">
                        <input [disabled]="field.isDisabled" matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip"   
                        [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                        ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px'  , 'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"  
                        [maxlength]="field.charLimit" (input)="onChange($event.target.value,item,field)"                         
                        [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                        [attr.value]="field.selectedValue"
                        type="text" [(ngModel)]='field.selectedValue'  id="{{field.id}}"
                        placeholder="{{field.fieldName}}">
                      </ng-container>                                   
                                                                
             </div>
           </div>
            </ng-container>


            <ng-container  *ngIf="(field.fieldTypeName=='Signature' || field.fieldTypeName=='Initials') && field.Control=='Static'">
              <div  [ngClass]="{'disableDiv': isPageLoaded && IsSigningComplete}" class="iframe-resize-container"
              [position]="{x: field.offsetX, y:field.offsetY}" 
              style="position: absolute;" [ngResizable]="!field.isDisabled" 
              [rzAspectRatio]="true"            
               [rzMinWidth]="40"
               [rzMaxWidth]="160"
               [rzMinHeight]="27"
               [rzMaxHeight]="105"
               [ngStyle]="{'position': 'absolute','width': field.offsetWidth+'px','height': field.offsetHeight+'px'}"                
               rzHandles="n,s,e,w,se,sw" [ngDraggable]="!field.isDisabled" [handle]="dragHandle"   
               (stopped)="onStop($event)" (movingOffset)="onMoving($event,item)"
               (endOffset)="onMoveEnd($event,item,field,'')"
               (rzStop)="onResizeStop($event,item,field.id)"
               [inBounds]="true">
              
              <!-- [bounds]="dragBounds" -->
              <!-- [appDisable]="field.isDisabled" -->
              
                <div class="iframe-drag-handle" id="dh{{field.id}}"                
                   
                   [ngStyle]="{'transform':'rotate('+field.rotation+'deg)'}"                   
                   #dragHandle>
                                             
                       <ng-container *ngIf="field.fieldTypeName=='Signature' && field.Control=='Static'">
                         <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500"
                          matTooltipClass="tooltip" *ngIf="field.isDisabled" 
                          style="background-color:#dddddd;cursor: not-allowed; pointer-events: all !important;border: 2px solid rgba(118, 118, 118, 0.3)!important;" 
                          [class.disabled]="field.isDisabled" id="{{field.id}}"  
                          class="customUpdate"
                          [ngClass]="{'ng-active' : field.ShowtoolDetail}">
                           <span id="border_color" *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0' style="cursor: not-allowed; pointer-events: all !important;">
                             <mat-icon>border_color</mat-icon>
                             Signature
                           </span>
                            <!-- Signature Stamp-->
                            <div class="sig-cell" *ngIf='field.signatureBase64 || field.signatureText && !field.signatureBase64 || field.ImageData.length>0' [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                             <div class="sig-chrome" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                               <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics</div>
                               <div class="sig-container" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                                 <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" />
                                 <ng-container *ngIf='field.signatureText && !field.signatureBase64'>
                                   <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}">{{field.signatureText}}</h3>
                                 </ng-container>
 
                                 <div *ngFor="let img of field.ImageData" class="uploadedData" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" >
                                   <img [src]="img.Imageurl" />
                                 </div>
 
                               </div>
                               <div class="sig-chrome-title-bottom ng-binding">{{field.participantEmailId}}</div>                             
                             </div>
                           </div>
                           <!-- Signature Stamp-->                         
                         </div>     
 
                         <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" 
                          matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="!field.isDisabled" [class.disabled]="field.isDisabled" id="{{field.id}}"
                          class="customUpdate" 
                          [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                          [ngClass]="{'bnone' : field.signatureBase64 || field.signatureText && !field.signatureBase64 || field.ImageData.length>0 }"
                          (click)="OpenSignPopup(AddSignature,item,field)">
                           <span id="border_color" *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0'>
                             <mat-icon>border_color</mat-icon>
                             Signature
                           </span>
 
                           <!-- Signature Stamp-->
                           <div class="sig-cell" *ngIf='field.signatureBase64 || field.signatureText && !field.signatureBase64 || field.ImageData.length>0' [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                             <div class="sig-chrome" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                               <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics</div>
                               <div class="sig-container" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                                 <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" />
                                 <ng-container *ngIf='field.signatureText && !field.signatureBase64'>
                                   <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}">{{field.signatureText}}</h3>
                                 </ng-container>
 
                                 <div *ngFor="let img of field.ImageData" class="uploadedData" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" >
                                   <img [src]="img.Imageurl" />
                                 </div>
                               </div>                             
                               <div class="sig-chrome-title-bottom ng-binding">{{field.participantEmailId}}</div>
                             </div>
                           </div>
                           <!-- Signature Stamp-->                     
                         </div>                   
                        </ng-container>  
                        
                        <ng-container *ngIf="field.fieldTypeName=='Initials' && field.Control=='Static'">
                         <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" matTooltipShowDelay="2500"
                          matTooltipClass="tooltip" *ngIf="field.isDisabled" 
                          style="background-color:#dddddd;cursor: not-allowed; pointer-events: all !important;border: 2px solid rgba(118, 118, 118, 0.3)!important;" 
                          [class.disabled]="field.isDisabled" id="{{field.id}}"  
                          class="customUpdate"
                          [ngClass]="{'ng-active' : field.ShowtoolDetail}">
                           <span id="initial_gesture" *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0' style="cursor: not-allowed; pointer-events: all !important;">
                             <mat-icon>gesture</mat-icon>
                             Initials
                           </span>
                            <!-- Initials Stamp-->
                            <div class="sig-cell" *ngIf='field.signatureBase64 || field.signatureText && !field.signatureBase64 || field.ImageData.length>0' [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                             <div class="sig-chrome" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                               <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics</div>
                               <div class="sig-container" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                                 <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" />
                                 <ng-container *ngIf='field.signatureText && !field.signatureBase64'>
                                   <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}">{{field.signatureText}}</h3>
                                 </ng-container>
 
                                 <div *ngFor="let img of field.ImageData" class="uploadedData" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" >
                                   <img [src]="img.Imageurl"/>
                                 </div>
 
                               </div>
                               <div class="sig-chrome-title-bottom ng-binding">{{field.participantEmailId}}</div>                             
                             </div>
                           </div>
                           <!-- Initials Stamp-->
                          
                         </div>     
 
                         <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}" 
                          matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="!field.isDisabled" [class.disabled]="field.isDisabled" id="{{field.id}}"
                          class="customUpdate" 
                          [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                          [ngClass]="{'bnone' : field.signatureBase64 || field.signatureText && !field.signatureBase64 || field.ImageData.length>0 }"
                          (click)="OpenSignPopup(AddInitial,item,field)">
                           <span id="initial_gesture" *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0'>
                             <mat-icon>gesture</mat-icon>
                             Initials
                           </span>
 
                           <!-- Initials Stamp-->
                           <div class="sig-cell" *ngIf='field.signatureBase64 || field.signatureText && !field.signatureBase64 || field.ImageData.length>0' 
                             [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                             <div class="sig-chrome" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" >
                               <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics</div>
                               <div class="sig-container">
                                 <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" />
                                 <ng-container *ngIf='field.signatureText && !field.signatureBase64'>
                                   <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}">{{field.signatureText}}</h3>
                                 </ng-container>
 
                                 <div *ngFor="let img of field.ImageData" class="uploadedData" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" >
                                   <img [src]="img.Imageurl"/>
                                 </div>
 
                               </div>                             
                               <div class="sig-chrome-title-bottom ng-binding">{{field.participantEmailId}}</div>
                             </div>
                           </div>
                           <!-- Initials Stamp-->                       
 
                         </div>                   
                        </ng-container>        
                                          
              </div>
            </div>
             </ng-container>

        </ng-container>
       
           <img  *ngIf='imageHeight!=0 && imageWidth!=0' [src]="item.img" alt="" [ngStyle]= "{ 'width':imageWidth +'px', 'height':imageHeight+'px'}" [ngClass]="{'progress': waitPointer}"  id="imgSrc{{i}}" (click)="onClickonImage($event,item)">             
           <img  *ngIf='imageHeight==0 && imageWidth==0' [src]="item.img" alt="" [ngStyle]= "{ 'width':imageWidth +'px', 'height':imageHeight+'px'}" [ngClass]="{'progress': waitPointer}"  id="imgSrc{{i}}" (click)="onClickonImage($event,item)">             
           
           <div id="imageDrawContainer" (click)="onClickonImage($event,item)" style="position: absolute;left: 0px; top: 0px;" *ngFor="let imgDrawn of item.drawings" [innerHtml]="imgDrawn">
             
           </div>
          </div>
    </div>

    <!-- *ngIf="auditPage" -->
    <div  id="auditHolder"  style="width: 100%;" class="auditHolder" [ngStyle]= "{ 'display':'none', 'width':imageWidth +'px', 'height':imageHeight+'px'}">
      <div class="header">
          <img src="../../../assets/images/logo/flowtrics_logo.png" alt="">
      </div>
      <div class="trailHolder" style="padding: 45px; font-size: 14px; width: 100%;" >
          <table cellspacing="0" cellspadding="0" style="width: 100%; min-width:680px; font-family: 'Roboto', sans-serif;"  width="100%"  >
              <!-- <tr>
                  <td style="text-transform: uppercase; color: #333; padding: 3px 10px; font-size: 14px;" ><b>Subject</b></td>
                  <td style="padding: 3px 10px; color: #333;" >{{Subject}}</td>
              </tr> -->
              <tr>
                  <td style="text-transform: uppercase; color: #333; padding: 3px 10px; font-size: 14px;" ><b>Document Name</b></td>
                  <td style="padding: 3px 10px; color: #333;" >{{DocumentName}}</td>
              </tr>
              <tr>
                  <td style="text-transform: uppercase; color: #333; padding: 3px 10px; font-size: 14px;" ><b>flowtrics Id</b></td>
                  <td style="padding: 3px 10px; color: #333;" >{{flowtricsId}}</td>
              </tr>
              <!-- <tr>
                  <td style="text-transform: uppercase; color: #333; padding: 3px 10px; font-size: 14px;" ><b>Participants</b></td>
                  <td style="padding: 3px 10px; color: #333;" >{{Participants}}</td>
              </tr> -->
              <tr>
                  <td style="text-transform: uppercase; color: #333; padding: 3px 10px; font-size: 14px;" ><b>Document</b></td>
                  <td style="padding: 3px 10px; color: #333;" >{{Document}}</td>
              </tr>
              <tr>
                  <td style="text-transform: uppercase; color: #333; padding: 3px 10px; font-size: 14px;" ><b>Status</b></td>
                  <td style="padding: 3px 10px; color:green; text-transform: uppercase;" >Completed</td>
              </tr>
              <tr>
                  <td colspan="2" style="padding: 3px 10px;">
                      <h3 style="margin: 15px 0 5px; font-weight: 500;" >Document History</h3>
                  </td>
              </tr>
  
              <!-- sepSection -->
  
  
              <ng-container *ngFor="let history of DocumentHistory">
                
                <tr class="documentHistory" style="background: #fafafa;" *ngIf="history.eventType == 'Sent'" >
                  <td style="text-transform: uppercase; color: #333;  padding:10px 10px 0px 10px;" >
                    <div class="state" style="display: flex; justify-content: space-between;  align-items: center; " >
                        <div class="nameIcon" style="display: flex; align-items: center;  width:120px;">
                          <img src="https://ecmstorageaccount.blob.core.windows.net/emailtemplateimages/mail_sent.png" width="24" height="24" alt="Icon" style="margin-right:8px" > {{history.eventType}}
                        </div> 
                        <div class="time" style="width:120px;">
                            <p style="margin: 0 0 3px 0;" ><b>{{history.createOn| date:'MM/dd/yyyy'}}</b></p>
                            <p style="margin: 0 0 3px 0;" >{{history.createOn| date:'h:mm:ss'}} UTC</p>                             
                        </div>
                    </div>
                   </td>
                   <td style="padding:10px 10px 0px 10px;"> 
                     <p style="margin: 0 0 5px 0;" >{{history.message}}</p>
                     <p style="margin: 0 0 5px 0; word-wrap: break-word;" *ngIf="history.eventType != 'Completed'">IP: {{history.ipAddress}}</p>                      
                   </td>
               </tr>
  
  
               <tr class="sepSection" *ngIf="history.eventType != 'Sent'" >
                <td style="text-transform: uppercase; color: #333; border-top: 1px solid #e2e2e2; padding:10px 10px 0px 10px;" >
                  <div class="state" style="display: flex; justify-content: space-between;  align-items: center;" >
                     <div class="nameIcon" style="display: flex; align-items: center; width: 150px;">
                         
                        <ng-container *ngIf="history.eventType == 'Viewed'">                           
                          <img src="https://ecmstorageaccount.blob.core.windows.net/emailtemplateimages/mail_viewed.png" width="24" height="24" alt="Icon" style="margin-right:8px"  > Viewed
                         </ng-container>
  
                         <ng-container style="margin: 0 0 5px 0;" *ngIf="history.eventType == 'Signed'">                          
                          <img src="https://ecmstorageaccount.blob.core.windows.net/emailtemplateimages/mail_signed.png" width="24" height="24" alt="Icon" style="margin-right:8px" > Signed 
                         </ng-container> 
  
                         <ng-container style="margin: 0 0 5px 0;" *ngIf="history.eventType == 'Completed'">                           
                          <img src="https://ecmstorageaccount.blob.core.windows.net/emailtemplateimages/mail_completed.png" width="24" height="24" alt="Icon" style="margin-right:8px" >Completed
                         </ng-container>
  
                     </div> 
                      <div class="time" style="width: 120px;">
                          <p style="margin: 0 0 3px 0;" ><b>{{history.createOn| date:'MM/dd/yyyy'}}</b></p>
                          <p style="margin: 0 0 3px 0;">{{history.createOn| date:'h:mm:ss'}} UTC</p>                             
                        </div>
                     </div>
                 </td>
                 <td style="border-top: 1px solid #e2e2e2; padding: 10px 10px 0px 10px;"> 
                      <p style="margin: 0 0 5px 0;" >{{history.message}}</p>
                      <p style="margin: 0 0 5px 0;" *ngIf="history.eventType != 'Completed'">IP: {{history.ipAddress}}</p>                      
                  </td>
              </tr>
    
              </ng-container>  
              
          </table>
      </div>
    </div>  
    
  </div>
 </div>
        
</div>
  
    <mat-card class="rblockPanel" *ngIf="isPageLoaded" [ngClass]="{'open' : showFiles}">
        <div class="allpages" *ngFor="let p of pjtDocumentImgThumbs ;let i = index">
          <mat-accordion>
            <ng-container>
              <mat-expansion-panel  [expanded]="indexExpanded == i">
                <mat-expansion-panel-header (click)='FillDocImagesWithFields(p.prjDocDetail.projectDocumentID,true,i)'>
                  <mat-panel-title>
                    {{p.prjDocDetail.documentName}}
                  </mat-panel-title>
                </mat-expansion-panel-header>
      
                <div class="page" *ngFor="let pg of p.pjtDocumentImgThumbs;let i = index" (click)='scrollToPage(i+1)'>
                  <span>{{pg.pageNumber}}</span>
                  <img [src]="pg.pageImageUrl" alt=""/>
                </div>
              </mat-expansion-panel>  
            </ng-container>
          </mat-accordion>
        </div>

      
    </mat-card>
      <div class="rblockOverlay" [ngClass]="{'open' : showFiles}" (click)="showAllFiles()"></div>
</div>


<ng-template #signature>
  <h2 mat-dialog-title>
     <span class="groupIcon" ><mat-icon>text_snippet</mat-icon></span>
      Add Signature
        <button mat-icon-button (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </h2>
  
<mat-dialog-content class="mat-typography">
 <div class="radOpts">
  <mat-radio-group aria-label="Select an option" color="primary"  [(ngModel)]="signOpt">
    <mat-radio-button value="draw">Draw</mat-radio-button>
    <mat-radio-button value="upload">Upload</mat-radio-button>
    <mat-radio-button value="type">Type In</mat-radio-button>
  </mat-radio-group>

 </div>

 <div class="allSCont">
  <ng-container *ngIf="signOpt == 'upload'">
    <div class="uploadholder">
      <mat-icon>note_add</mat-icon>
      <p>Drop your signature here or click here to upload</p>
      <span>File extension should be .png</span>
      <input type="file"/>
    </div>
  </ng-container>
  
    <ng-container *ngIf="signOpt == 'draw'">
      <signature-pad [options]="signaturePadOptions"  (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete()"></signature-pad>
    </ng-container>
  
    <ng-container *ngIf="signOpt == 'type'">
      <div class="divideCol">
        <div class="left blk">
          <mat-form-field class="example-full-width">
            <mat-label>Enter Name</mat-label>
            <input matInput required placeholder="Enter name" value="" [(ngModel)]="signName">
          </mat-form-field>
        </div>
        <div class="right blk">
          <mat-form-field class="example-full-width">
            <mat-label>Select Font</mat-label>
            <select matNativeControl required>
              <option value="1">Roboto</option>
              <option value="2">Signature 1</option>
              <option value="3">Signature 2</option>
              <option value="3">Signature 3</option>
            </select>
          </mat-form-field>
        </div>
      </div>
      <div class="allSign">
        <div class="signlook" style="font-family: 'Indie Flower', cursive;">
          {{signName}}
        </div>
      </div>
    </ng-container>
 </div>  
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="close()" class="clear" color="warn">Clear</button>
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary">Save</button>
</mat-dialog-actions>
</ng-template>

<ng-template #fillRequried>
    <h2 mat-dialog-title>
       <span class="groupIcon" ><mat-icon>text_snippet</mat-icon></span>
        Fill Required Fields
          <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
          </button>
        </h2>
    
  <mat-dialog-content class="mat-typography">
  
    <form class="example-form">
      <mat-form-field class="example-full-width">
        <mat-label>First Name</mat-label>
        <input matInput required placeholder="Enter first name" value="">
      </mat-form-field>
      <mat-form-field class="example-full-width">
        <mat-label>Last Name</mat-label>
        <input matInput required placeholder="Enter last name" value="">
      </mat-form-field>
      <mat-form-field class="example-full-width">
        <mat-label>Email</mat-label>
        <input matInput required placeholder="Enter email" value="">
      </mat-form-field>
      <mat-form-field class="example-full-width">
        <mat-label>Phone</mat-label>
        <input matInput required placeholder="Enter phone" value="">
      </mat-form-field>
    </form>
  
    
  </mat-dialog-content>
  <mat-dialog-actions >
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary">Save</button>
  </mat-dialog-actions>
</ng-template>
  
<ng-template #fillForm>
  <h2 mat-dialog-title>
      <span class="groupIcon"><mat-icon>text_snippet</mat-icon></span>
      Fill Form
      <button mat-icon-button (click)="cancelFillForm()">
        <mat-icon>close</mat-icon>
      </button>
  </h2>
  
  <mat-dialog-content class="mat-typography">
    <div class="autoFill">
      <!-- <mat-checkbox color="primary" (change)="onAutoFillChanged($event)">Auto fill values with my saved record</mat-checkbox> -->
      <button *ngIf="!autoFill" mat-stroked-button color="primary" (click)="onAutoFillChanged($event)" > <mat-icon>checklist</mat-icon> Auto fill values</button>
      <button *ngIf="autoFill" mat-flat-button color="primary" (click)="onAutoFillChanged($event)" > <mat-icon>check_circle</mat-icon> Auto fill values</button>
    </div>
 

    <mat-accordion  class="signaccor" multi>

      <mat-expansion-panel *ngIf='particiantJsonListAutoFill.length>0 && groupRelationParticipantId!=0' [expanded]="openPanel===1">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{contactModule}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        
        <div style="overflow-y: auto;" *ngFor="let item of particiantJsonListAutoFill;let i= index;">
          <ng-container *ngFor="let field of filedsForFillForm(item.fields);let j= index;">
                    
          <ng-container  *ngIf="field.selectedParticipant?.groupRelationParticipantMappingID>0 && field.fieldTypeName!=='Checkbox' && field.fieldTypeName!=='Radio'
              && field.fieldTypeName!=='CheckBoxGroup' && field.fieldTypeName!=='Image'">            
              <div  class="iframe-resize-container"
                [ngClass]="{'fileControl' :field.fieldTypeName=='Draw' || field.fieldTypeName=='Signature' || field.fieldTypeName=='Initials'  }"                
                
                 (click)="verifyParticipant(field,$event)"
                *ngIf="!field.isDisabled">
               
                <div class="iframe-drag-handle"   (click)="addActiveClass(field)"
                      [ngStyle]="{'transform':'rotate('+field.rotation+'deg)'}"
                      [attr.field]="field.id" [attr.tabIndex]="setTabIndex(i,j)"
                        #dragHandle>
                
    
                        <ng-container *ngIf="field.fieldTypeName=='Textbox'">
                          <form class="fillformOpt">
                            <mat-form-field class="example-full-width">
                              <mat-label>{{formatSubfolderName(field.subFolderName)}} {{field.fieldName}} <sup [ngClass]="{'ng-show-required' : field.showRequiredControls}">*</sup></mat-label>
                              <input   matInput
                              [ngModelOptions]="{standalone: true}" [maxlength]="field.charLimit" (input)="onChange($event.target.value,item,field)" 
                           
                              type="text" [(ngModel)]='field.selectedValue'  id="{{field.id}}"
                              placeholder="{{field.fieldName}}" (click)="OpentoolDetail('Textbox')"
                              (click)="OpentoolDetailText(item,field.id)">
                            </mat-form-field>
                            </form>
                      
                        </ng-container> 
    
                        <ng-container *ngIf="field.fieldTypeName=='Currency'">
                          <form class="fillformOpt">
                            <mat-form-field class="example-full-width">
                              <mat-label>{{formatSubfolderName(field.subFolderName)}} {{field.fieldName}} <sup [ngClass]="{'ng-show-required' : field.showRequiredControls}">*</sup></mat-label>
                              <input   matInput
                              [ngModelOptions]="{standalone: true}" [maxlength]="field.charLimit" (input)="onChange($event.target.value,item,field)" 
                           
                              type="text" [(ngModel)]='field.selectedValue'  id="{{field.id}}"
                              placeholder="{{field.fieldName}}" (click)="OpentoolDetail('Textbox')"
                              (click)="OpentoolDetailText(item,field.id)">
                            </mat-form-field>
                            </form>
                      
                        </ng-container> 

                        <ng-container *ngIf="field.fieldTypeName=='Textarea'">
                        <form class="fillformOpt">
                        <mat-form-field class="example-full-width">
                        <mat-label>{{formatSubfolderName(field.subFolderName)}} {{field.fieldName}} <sup [ngClass]="{'ng-show-required' : field.showRequiredControls}">*</sup></mat-label>
                        <textarea matInput   [attr.maxLength]="field.charLimit"  [innerHtml]='field.selectedValue' (input)="onChangeTexarea($event.target.value,item,field)"
                       (click)="OpentoolDetail('Textarea')" class="form-control"  id="{{field.id}}" placeholder="{{field.fieldName}}"
                       [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                       (click)="OpentoolDetailText(item,field.id)"></textarea>
                      </mat-form-field>
                      </form> 
                    
                        </ng-container>
    
    
                        <ng-container *ngIf="field.fieldTypeName=='Number'">
                          <form class="fillformOpt">
                            <mat-form-field class="example-full-width">
                              <mat-label>{{formatSubfolderName(field.subFolderName)}} {{field.fieldName}} <sup [ngClass]="{'ng-show-required' : field.showRequiredControls}">*</sup></mat-label>
                              <input matInput [(ngModel)]='field.selectedValue'  [ngModelOptions]="{standalone: true}" type="text" class="form-control"  id="{{field.id}}"
                            (input)="onChange($event.target.value,item,field)" (click)="OpentoolDetail('Number')"
                            (keypress)="numberOnly($event)"  id="{{field.id}}" (click)="OpentoolDetailText(item,field.id)">
                            </mat-form-field>
                            </form>
                        </ng-container>
    
    
                        <ng-container *ngIf="field.fieldTypeName=='Dropdown'">
                          <mat-form-field >
                            <mat-label>Select {{field.placeholder}} <sup [ngClass]="{'ng-show-required' : field.showRequiredControls}">*</sup></mat-label>
                          <mat-select  id="{{field.id}}" [ngStyle]="{
                              'color': field.fontColor,
                              'text-align': field.textalign,
                              'font-weight': field.fontstyle,
                              'font-style': field.fontweight,
                              'font-size': field.fontSize,
                              'font-family': field.fontfamily
                              }"
                          [disabled]="field.isDisabled"
                          (click)="OpentoolDetail('Dropdown')"
                          (click)="OpentoolDetailDropDown(item,field.id)"
                          (selectionChange)="setDdlValue($event,item,field)" 
                          [(ngModel)]="field.selectedValue" [attr.value]="field.selectedValue"
                          placeholder={{field.selectedValue}}>
                            <mat-option [ngStyle]="{
                              'color': field.fontColor,
                              'text-align': field.textalign, 
                              'font-weight': field.fontstyle, 
                              'field-style': field.fontweight,  
                              'font-size': field.fontSize, 
                              'font-family': field.fontfamil}"
                            *ngFor="let drp of field.fillList" [value]="drp.val">
                              {{ drp.val }}
                            </mat-option>
                          </mat-select>     
                        </mat-form-field>       
                        </ng-container>                                    
                       
    
                        <ng-container *ngIf="field.fieldTypeName=='MultiSelect'">
    
                          <mat-form-field >
                            <mat-label>Select {{field.placeholder}} <sup [ngClass]="{'ng-show-required' : field.showRequiredControls}">*</sup></mat-label>
                          
                          <mat-select  id="{{field.id}}" [ngStyle]="{
                            'color': field.fontColor, 
                            'text-align': field.textalign, 
                            'font-weight': field.fontstyle, 
                            'font-style': field.fontweight, 
                            'font-size': field.fontSize, 
                            'font-family': field.fontfamily
                            }"
                          color="primary" [ngModel]="field.selectedValue" 
                          (selectionChange)="setDdlValue($event,item,field)"
                          (click)="OpentoolDetail('MultiSelect')"
                          (click)="OpentoolDetailMulDropDown(item,field.id)"                
                           [required]='field.isRequired' multiple>
                          <mat-option *ngFor="let muldrp of field.fillList" [value]="muldrp.val">
                            {{ muldrp.val }}
                          </mat-option>
                        </mat-select>   
                        </mat-form-field>              
                       </ng-container>
    
                        <ng-container *ngIf="field.fieldTypeName=='Currency'">
                    <input [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily
                     ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px'}"  
                     type="text" [(ngModel)]='field.selectedValue' (input)="onChange($event.target.value,item,field)" 
                      class="form-control" id="{{field.id}}" placeholder="{{field.placeholder}}"
                     (click)="OpentoolDetail('Number')"
                     (click)="OpentoolDetailText(item,field.id)">
                        </ng-container>
    
                       <ng-container *ngIf="field.fieldTypeName=='URL'">
                    <input  [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily}"  
                    type="text" [value]='field.selectedValue' 
                    (input)="onChange($event.target.value,item,field)" 
                    (click)="OpentoolDetail('URL')"
                    (click)="OpentoolDetailText(item,field.id)"
                    class="form-control"  id="{{field.id}}" placeholder="{{field.placeholder}}">
                       </ng-container>              
                     
    
                       <ng-container *ngIf="field.fieldTypeName=='Address'">
                      <input  [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily}"  
                       type="text" class="form-control"  id="{{field.id}}" placeholder="{{field.placeholder}}"
                       [value]='field.selectedValue'>
                       </ng-container>

                       <ng-container *ngIf="field.fieldTypeName=='City'">
                        <mat-form-field>
                          <mat-label>City</mat-label>
                        <input class="form-control" [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight,
                        'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"  placeholder="{{field.fieldName}}" 
                        type="text"  id="{{field.id}}" placeholder="{{field.placeholder}}"
                        [(ngModel)]='field.selectedValue'
                        matInput                
                        (input)="onChange($event.target.value,item,field)"       
                        (input)="searchCity($event.target.value)" 
                        [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="cityselected($event,item,field.id)">
                          <mat-option *ngFor="let option of cityOption" [value]="option">
                            {{option}}
                          </mat-option>
                        </mat-autocomplete>
                        </mat-form-field>
                       </ng-container>
                          

                       <ng-container *ngIf="field.fieldTypeName=='State'">
                        <mat-form-field >
                          <mat-label>Select State</mat-label>
                        <mat-select  id="{{field.id}}" [ngStyle]="{
                            'color': field.fontColor,
                            'text-align': field.textalign,
                            'font-weight': field.fontstyle,
                            'font-style': field.fontweight,
                            'font-size': field.fontSize,
                            'font-family': field.fontfamily
                            }"
                        [disabled]="field.isDisabled"
                        (click)="OpentoolDetail('Dropdown')"
                        (click)="OpentoolDetailDropDown(item,field.id)"
                        (selectionChange)="setDdlValue($event,item,field)" 
                        [(ngModel)]="field.selectedValue"
                        placeholder={{field.selectedValue}}>
                        <mat-option>None</mat-option>  
                        <mat-option [ngStyle]="{
                            'color': field.fontColor,
                            'text-align': field.textalign, 
                            'font-weight': field.fontstyle, 
                            'field-style': field.fontweight,  
                            'font-size': field.fontSize, 
                            'font-family': field.fontfamil}"
                          *ngFor="let state of stateList" [value]="state">
                            {{ state }}
                          </mat-option>
                        </mat-select>     
                      </mat-form-field>       
                      </ng-container> 
                      

                      <ng-container *ngIf="field.fieldTypeName=='Zip'">
                        <mat-form-field>
                          <mat-label>Zip Code</mat-label>
                        <input class="form-control" [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight,
                        'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"  placeholder="{{field.fieldName}}" 
                        type="text"   id="{{field.id}}" placeholder="{{field.placeholder}}"
                        [(ngModel)]='field.selectedValue' 
                        matInput               
                        (input)="onChange($event.target.value,item,field)"   
                        (input)="searchZip($event.target.value)" 
                        [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="zipselected($event,item,field.id)">
                          <mat-option *ngFor="let option of zipOption" [value]="option">
                            {{option}}
                          </mat-option>
                        </mat-autocomplete>
                        </mat-form-field>
                       </ng-container>
    
                      <ng-container *ngIf="field.fieldTypeName=='Location'">
                    <div  id="{{field.id}}" class="customUpdate"
                    (click)="OpentoolDetail('Location')" (click)="fetchLocation(item,field.id)"
                    [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                    [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}">
                      <span *ngIf='!field.Lat && !field.Long'>
                        <mat-icon>location_on</mat-icon>
                        Location
                      </span>
                      <ng-container  *ngIf='field.Lat && field.Long'>
                      <h3 [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily}"  > 
                        Lat : {{field.Lat}}
                        Long: {{field.Long}}
                      </h3>
                     </ng-container>
                                  
                    </div>                   
                      </ng-container>  
    
                      <ng-container *ngIf="field.fieldTypeName=='Date'">
                     <div class="Dtime">
    
                     <mat-form-field>
                      <input  id="{{field.id}}" matInput type="text" [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 
                     'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily}"  
                      [ngModel]="field.selectedValue |date:'yyyy-MM-dd'" placeholder="{{field.fieldName}}"                       
                      (input)="onChange($event.target.value,item,field)" readonly
                      (dateChange)="onChange($event.target.value,item,field)"
                      (click)="OpentoolDetail('Date')"
                      (click)="OpentoolDetailText(item,field.id)"  
                     [matDatepicker]="basicDatepicker"/>
                   <mat-datepicker-toggle matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
                   <mat-datepicker #basicDatepicker ></mat-datepicker> 
                     </mat-form-field>    
                     </div>
                                 
                      </ng-container>
                   
                     <ng-container *ngIf="field.fieldTypeName=='Time'">
                    <div class="Dtime"                        
                    [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                    [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}">
                      <input id="{{field.id}}" type="text" [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                      aria-label="default time" [ngxTimepicker]="toggleTimepicker" (click)="OpentoolDetail('Time')" 
                      (click)="OpentoolDetailText(item,field.id)" matInput  placeholder="{{field.fieldName}}" [(ngModel)]='field.selectedValue' readonly>
                    <ngx-material-timepicker-toggle matSuffix [for]="toggleTimepicker"></ngx-material-timepicker-toggle>
                    <ngx-material-timepicker (timeSet)="onChange($event,item,field)"  #toggleTimepicker>
                    </ngx-material-timepicker>
                    </div>
                     </ng-container>
                  
                        
                      <ng-container *ngIf="field.fieldTypeName=='File'">
                          <div class="customUpdate" (click)="OpentoolDetail('File')"  id="{{field.id}}"
                          (click)="OpentoolDetailText(item,field.id)"
                          [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                          [ngClass]="{'ng-active' : field.ShowtoolDetail}">
                            <span id="cloud_upload" *ngIf='field.FileData.length==0'>
                              <mat-icon>cloud_upload</mat-icon>
                              Upload File
                            </span>                    
    
                            <div *ngFor="let file of field.FileData" class="uploadedData">
                              <p>{{file.FullPath}}</p>
                          </div>
                          <input type="file" class="form-control" id="{{field.fieldName}}" 
                          (change)="onSelectFile($event,item,field.id)" placeholder="{{field.fieldName}}">
                          </div>
                      </ng-container>                 
    
                        <ng-container *ngIf="field.fieldTypeName=='Signature'">
                          <div  id="{{field.id}}" class="customUpdate" 
                          [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                          [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                          (click)="OpentoolDetail('Signature')" (click)="OpenSignPopup(AddSignature,item,field)">
                            <span id="border_color" *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0'>
                              <mat-icon>border_color</mat-icon>
                              Signature
                            </span>
                            <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" /> 
                          
                            <ng-container  *ngIf='field.signatureText && !field.signatureBase64'>
                            <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}" >{{field.signatureText}}</h3>
                          </ng-container>
                            <div *ngFor="let img of field.ImageData" class="uploadedData">
                              <img [src]="img.Imageurl"  [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}"/> 
                          </div>                
                          </div>                   
                        </ng-container>  
                        
                        <ng-container *ngIf="field.fieldTypeName=='Draw'">
                          <div  id="{{field.id}}" class="customUpdate" (click)="OpentoolDetail('Draw')" 
                          (click)="OpenDrawPopup(Draw,item,field,field.id)"
                          [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                          [ngClass]="{'ng-active' : field.ShowtoolDetail}">
                            <span id="draw_brush" *ngIf='!field.drawBase64  && field.ImageData.length==0'>
                              <mat-icon>brush</mat-icon>
                              Draw
                            </span>                                  
                            <img *ngIf='field.drawBase64' [src]="field.drawBase64"  [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}"/>  
                          </div>                   
                        </ng-container>  
    
                        <ng-container *ngIf="field.fieldTypeName=='Drawpopup'">
                          <div  id="{{field.id}}" class="customUpdate" (click)="OpentoolDetail('Draw1')" (click)="OpenDrawInPopup(DrawInPopup)" >
                            <span id="draw_brush" *ngIf='!field.drawBase64  && field.ImageData.length==0'>
                              <mat-icon>brush</mat-icon>
                              Draw
                            </span>                                  
                            <img *ngIf='field.drawBase64' [src]="field.drawBase64" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}"/>  
                          </div>                   
                        </ng-container>
                      
                        <ng-container *ngIf="field.fieldTypeName=='Initials'">
                          <div  id="{{field.id}}" class="customUpdate" 
                          [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                          [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                          (click)="OpentoolDetail('Initials')" (click)="OpenSignPopup(AddInitial,item,field)">
                            <span id="initial_gesture" *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0'>
                            <mat-icon>gesture</mat-icon>
                              Initials
                            </span>
                            <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" /> 
                            <ng-container  *ngIf='field.signatureText && !field.signatureBase64' >
                              <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}" >{{field.signatureText}}</h3>
                            </ng-container>
                            <div *ngFor="let img of field.ImageData" class="uploadedData">
                              
                              <img [src]="img.Imageurl"  [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}"/> 
                          </div>                
                          </div>                   
                        </ng-container>  
                      
                        
                        <ng-container *ngIf="field.fieldTypeName=='Button'">
                          <a [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                         class="btn-primary btnGlobal"  id="{{field.id}}"
                          href="{{field.buttonURL}}" target="_blank"
                          (click)="OpentoolDetail('Button')" 
                          (click)="OpentoolDetailText(item,field.id)">{{field.buttonName}}</a>
                        </ng-container>                  
                      
              </div>
            </div>
          </ng-container>
    
          <ng-container  *ngIf="field.selectedParticipant?.groupRelationParticipantMappingID>0 && field.fieldTypeName=='Checkbox' || field.fieldTypeName=='Radio' ||
          field.fieldTypeName=='CheckBoxGroup'">
            <div class="radioHolder"  id="{{field.id}}"  *ngIf="!field.isDisabled" >
              <div *ngFor="let ele of field.fillList; let i=index"  class="iframe-resize-container"  [attr.field]="field.id"
              
              [ngClass]="{'ng-show-required' : field.showRequiredControls}"
            
              (click)="verifyParticipant(field,$event)">
             
              <div class="iframe-drag-handle"  [attr.field]="field.id"  
            
              #dragHandle [attr.tabIndex]="setTabIndex(i,j)">
              <ng-container *ngIf="field.fieldTypeName=='Checkbox'">
                <label 
                [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                }"
                class="checkboxfield" (click)="OpentoolDetail('Checkbox')"
                (click)="OpentoolDetailCheckBox(item,field.id,ele.id)">                
                    <input type="checkbox" class="mat-checkbox-input"   [checked]='ifChkCheckedAutoFill(field,item,ele.id)'
                      (click)="OnChangeCheckBox($event, ele.val, field,item,ele.id)">
                    {{ele.val}}               
                </label>
               
              </ng-container>
    
              <ng-container *ngIf="field.fieldTypeName=='Radio'">
              <div class="flexCol"  id="{{field.id}}"> 
                <label  [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                }"
                class="radiofield" (click)="OpentoolDetail('Radio')"
                (click)="OpentoolDetailRadioButtonGroup(item,field.id,ele.id)">                
                  <input type="radio" class="mat-checkbox-input" 
                  
                  [attr.Checked]="ifRadioChecked(field.id,item,ele.id)? 'checked' : null"  
                  name='{{field.id}}' [checked]='ifRadioChecked(field.id,item,ele.id)' [value]="ele.val" (change)="OnChangeRadio($event, ele.val, field.id,item,ele.id)" >
                  {{ele.val}}
                </label>                  
                
              </div>
            
              </ng-container>
    
              <ng-container *ngIf="field.fieldTypeName=='CheckBoxGroup'">
                <div class="flexCol"  id="{{field.id}}">
                <label [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                class="checkboxfield" (click)="OpentoolDetail('CheckBoxGroup')"
                (click)="OpentoolDetailCheckBoxGroup(item,field.id,ele.id)">                   
                  
                  <input class="mat-checkbox-input" type="checkbox"        
                    [attr.checked]="ifChkChecked(field.id,item,ele.id)? 'checked' : null" [checked]='ifChkChecked(field.id,item,ele.id)' (change)="OnChangeCheckBoxGroup($event, ele.val, field.id,item,ele.id)">
                  {{ele.val}}
                </label>       
                </div>
              </ng-container>
    
            </div>
          </div>
          </div>
          </ng-container>
    
    
          <ng-container  *ngIf="field.selectedParticipant?.groupRelationParticipantMappingID>0 && field.fieldTypeName=='Image'">
          <div class="radioHolder"  id="{{field.id}}"  *ngIf="!field.isDisabled">
            <div *ngFor="let ele of field.fillList; let i=index"  class="iframe-resize-container"  [attr.field]="field.id"
            [ngClass]="{'fileControl' :field.fieldTypeName=='Image'}" 
            [ngStyle]="{'height': field.Imageheight, 'width': field.Imagewidth}" 
            style="position: absolute"  
            (click)="verifyParticipant(field,$event)">
            <div class="iframe-drag-handle" (click)="addActiveClass(field)"  [attr.field]="field.id" 
            [attr.tabIndex]="setTabIndex(i,j)"  [ngClass]="{'ng-active' : field.ShowtoolDetail}"
            #dragHandle>
    
            <ng-container *ngIf="field.fieldTypeName=='Image'">
              <div class="customUpdate" (click)="OpentoolDetail('Image')"  id="{{field.id}}"
              (click)="OpentoolDetailText(item,field.id)"
              [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
              
              [ngClass]="{'ng-active' : field.ShowtoolDetail}"
              [ngClass]="{'ng-show-required' : field.showRequiredControls}">
                <span id="cloud_upload" *ngIf='field.ImageData.length==0'>
                  <mat-icon>cloud_upload</mat-icon>
                  Upload Image
                </span>
                <div *ngFor="let img of field.ImageData" class="uploadedData">
                  <img *ngIf='img.Imageurl' [src]="img.Imageurl" [ngStyle]="{'height': field.Imageheight, 'width': field.Imagewidth}"/> 
              </div>                  
                                
              <input type="file" class="form-control" accept="image/*" id="{{field.fieldName}}" 
              (change)="onSelectImage($event,item,field.id)" placeholder="{{field.fieldName}}">
              </div>                   
            </ng-container> 
    
            
                </div>
              </div>
            </div>
            </ng-container>
    
          
          </ng-container>
        </div>
        
      </mat-expansion-panel>

      <mat-expansion-panel *ngIf='particiantJsonListAutoFillCore.length>0' [expanded]="openPanel===2">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{coreModule}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div style="overflow-y: auto;" *ngFor="let item of particiantJsonListAutoFillCore;let i= index;">
          <ng-container *ngFor="let field of filedsForFillForm(item.fields);let j= index;">
                    
              <ng-container  *ngIf="field.selectedParticipant?.groupRelationParticipantMappingID>-1 && field.fieldTypeName!=='Checkbox' && field.fieldTypeName!=='Radio'
              && field.fieldTypeName!=='CheckBoxGroup' && field.fieldTypeName!=='Image'">            
              <div  class="iframe-resize-container"
                [ngClass]="{'fileControl' :field.fieldTypeName=='Draw' || field.fieldTypeName=='Signature' || field.fieldTypeName=='Initials'  }"                
                
                 (click)="verifyParticipant(field,$event)"
                *ngIf="!field.isDisabled">
               
                <div class="iframe-drag-handle"   (click)="addActiveClass(field)"
                      [ngStyle]="{'transform':'rotate('+field.rotation+'deg)'}"
                      [attr.field]="field.id" [attr.tabIndex]="setTabIndex(i,j)"
                        #dragHandle>
                
    
                        <ng-container *ngIf="field.fieldTypeName=='Textbox'">
                          <form class="fillformOpt">
                            <mat-form-field class="example-full-width" >
                              <mat-label>{{formatSubfolderName(field.subFolderName)}} {{field.fieldName}} <sup *ngIf="field.showRequiredControls">*</sup></mat-label>
                              <input   matInput 
                              [ngModelOptions]="{standalone: true}" [maxlength]="field.charLimit" (input)="onChange($event.target.value,item,field)" 
                           
                              type="text" [(ngModel)]='field.selectedValue'  id="{{field.id}}"
                              placeholder="{{field.fieldName}}" (click)="OpentoolDetail('Textbox')"
                              (click)="OpentoolDetailText(item,field.id)">
                            </mat-form-field>
                            </form>
                      
                        </ng-container> 
    
                        <ng-container *ngIf="field.fieldTypeName=='Currency'">
                          <form class="fillformOpt">
                            <mat-form-field class="example-full-width" >
                              <mat-label>{{formatSubfolderName(field.subFolderName)}} {{field.fieldName}} <sup *ngIf="field.showRequiredControls">*</sup></mat-label>
                              <input   matInput 
                              [ngModelOptions]="{standalone: true}" [maxlength]="field.charLimit" (input)="onChange($event.target.value,item,field)" 
                           
                              type="text" [(ngModel)]='field.selectedValue'  id="{{field.id}}"
                              placeholder="{{field.fieldName}}" (click)="OpentoolDetail('Textbox')"
                              (click)="OpentoolDetailText(item,field.id)">
                            </mat-form-field>
                            </form>
                      
                        </ng-container> 

                        <ng-container *ngIf="field.fieldTypeName=='Textarea'">
                        <form class="fillformOpt">
                        <mat-form-field class="example-full-width">
                        <mat-label>{{formatSubfolderName(field.subFolderName)}} {{field.fieldName}} <sup *ngIf="field.showRequiredControls">*</sup></mat-label>
                        <textarea matInput   [attr.maxLength]="field.charLimit"  [innerHtml]='field.selectedValue' (input)="onChangeTexarea($event.target.value,item,field)"
                       (click)="OpentoolDetail('Textarea')" class="form-control"  id="{{field.id}}" placeholder="{{field.fieldName}}"
                       [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                       (click)="OpentoolDetailText(item,field.id)"></textarea>
                      </mat-form-field>
                      </form> 
                    
                        </ng-container>
    
    
                        <ng-container *ngIf="field.fieldTypeName=='Number'">
                          <form class="fillformOpt">
                            <mat-form-field class="example-full-width">
                              <mat-label>{{formatSubfolderName(field.subFolderName)}} {{field.fieldName}} <sup *ngIf="field.showRequiredControls">*</sup></mat-label>
                              <input matInput [(ngModel)]='field.selectedValue'  [ngModelOptions]="{standalone: true}" type="text" class="form-control"  id="{{field.id}}"
                            (input)="onChange($event.target.value,item,field)" (click)="OpentoolDetail('Number')"
                            (keypress)="numberOnly($event)"  id="{{field.id}}" (click)="OpentoolDetailText(item,field.id)">
                            </mat-form-field>
                            </form>
                        </ng-container>
    
    
                        <ng-container *ngIf="field.fieldTypeName=='Dropdown'">
                          <mat-form-field >
                            <mat-label>Select {{field.placeholder}} <sup *ngIf="field.showRequiredControls">*</sup></mat-label>
                          <mat-select  id="{{field.id}}" [ngStyle]="{
                              'color': field.fontColor,
                              'text-align': field.textalign,
                              'font-weight': field.fontstyle,
                              'font-style': field.fontweight,
                              'font-size': field.fontSize,
                              'font-family': field.fontfamily
                              }"
                          [disabled]="field.isDisabled"
                          (click)="OpentoolDetail('Dropdown')"
                          (click)="OpentoolDetailDropDown(item,field.id)"
                          (selectionChange)="setDdlValue($event,item,field)" 
                          [(ngModel)]="field.selectedValue" [attr.value]="field.selectedValue"
                          placeholder={{field.selectedValue}}>
                            <mat-option [ngStyle]="{
                              'color': field.fontColor,
                              'text-align': field.textalign, 
                              'font-weight': field.fontstyle, 
                              'field-style': field.fontweight,  
                              'font-size': field.fontSize, 
                              'font-family': field.fontfamil}"
                            *ngFor="let drp of field.fillList" [value]="drp.val">
                              {{ drp.val }}
                            </mat-option>
                          </mat-select>     
                        </mat-form-field>       
                        </ng-container>                                    
                       
    
                        <ng-container *ngIf="field.fieldTypeName=='MultiSelect'">
    
                          <mat-form-field >
                            <mat-label>Select {{field.placeholder}} <sup *ngIf="field.showRequiredControls">*</sup></mat-label>
                          
                          <mat-select  id="{{field.id}}" [ngStyle]="{
                            'color': field.fontColor, 
                            'text-align': field.textalign, 
                            'font-weight': field.fontstyle, 
                            'font-style': field.fontweight, 
                            'font-size': field.fontSize, 
                            'font-family': field.fontfamily
                            }"
                          color="primary" [ngModel]="field.selectedValue" 
                          (selectionChange)="setDdlValue($event,item,field)"
                          (click)="OpentoolDetail('MultiSelect')"
                          (click)="OpentoolDetailMulDropDown(item,field.id)"                
                           [required]='field.isRequired' multiple>
                          <mat-option *ngFor="let muldrp of field.fillList" [value]="muldrp.val">
                            {{ muldrp.val }}
                          </mat-option>
                        </mat-select>   
                        </mat-form-field>              
                       </ng-container>
    
                        <ng-container *ngIf="field.fieldTypeName=='Currency'">
                    <input [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily
                     ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px'}"  
                     type="text" [(ngModel)]='field.selectedValue' (input)="onChange($event.target.value,item,field)" 
                      class="form-control" id="{{field.id}}" placeholder="{{field.placeholder}}"
                     (click)="OpentoolDetail('Number')"
                     (click)="OpentoolDetailText(item,field.id)">
                        </ng-container>
    
                       <ng-container *ngIf="field.fieldTypeName=='URL'">
                    <input  [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily}"  
                    type="text" [value]='field.selectedValue' 
                    (input)="onChange($event.target.value,item,field)" 
                    (click)="OpentoolDetail('URL')"
                    (click)="OpentoolDetailText(item,field.id)"
                    class="form-control"  id="{{field.id}}" placeholder="{{field.placeholder}}">
                       </ng-container>              
                     
    
                       <ng-container *ngIf="field.fieldTypeName=='Address'">
                        <form class="fillformOpt">
                          <mat-form-field class="example-full-width" >
                            <mat-label>{{formatSubfolderName(field.subFolderName)}} {{field.fieldName}} <sup *ngIf="field.showRequiredControls">*</sup></mat-label>
                            <input   matInput 
                            [ngModelOptions]="{standalone: true}" [maxlength]="field.charLimit" (input)="onChange($event.target.value,item,field)" 
                         
                            type="text" [(ngModel)]='field.selectedValue'  id="{{field.id}}"
                            placeholder="{{field.fieldName}}" (click)="OpentoolDetail('Textbox')"
                            (click)="OpentoolDetailText(item,field.id)">
                          </mat-form-field>
                          </form>
                    
                      </ng-container>
    
                       <ng-container *ngIf="field.fieldTypeName=='City'">
                        <mat-form-field>
                          <mat-label>City</mat-label>
                        <input  [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight,
                        'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                       }"  placeholder="{{field.fieldName}}" 
                        type="text"  id="{{field.id}}" placeholder="{{field.placeholder}}"
                        [(ngModel)]='field.selectedValue'  
                        (input)="onChange($event.target.value,item,field)"                   
                        (input)="searchCity($event.target.value)" 
                        [matAutocomplete]="auto"
                        matInput
                        >
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="cityselected($event,item,field.id)">
                          <mat-option *ngFor="let option of cityOption" [value]="option">
                            {{option}}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>
                       </ng-container>
                          

                       <ng-container *ngIf="field.fieldTypeName=='State'">
                        <mat-form-field >
                          <mat-label>Select State</mat-label>
                        <mat-select  id="{{field.id}}" [ngStyle]="{
                            'color': field.fontColor,
                            'text-align': field.textalign,
                            'font-weight': field.fontstyle,
                            'font-style': field.fontweight,
                            'font-size': field.fontSize,
                            'font-family': field.fontfamily
                            }"
                        [disabled]="field.isDisabled"
                        (click)="OpentoolDetail('Dropdown')"
                        (click)="OpentoolDetailDropDown(item,field.id)"
                        (selectionChange)="setDdlValue($event,item,field)" 
                        [(ngModel)]="field.selectedValue"
                        placeholder={{field.selectedValue}}>
                        <mat-option>None</mat-option>  
                        <mat-option [ngStyle]="{
                            'color': field.fontColor,
                            'text-align': field.textalign, 
                            'font-weight': field.fontstyle, 
                            'field-style': field.fontweight,  
                            'font-size': field.fontSize, 
                            'font-family': field.fontfamil}"
                          *ngFor="let state of stateList" [value]="state">
                            {{ state }}
                          </mat-option>
                        </mat-select>     
                      </mat-form-field>       
                      </ng-container> 
                      

                      <ng-container *ngIf="field.fieldTypeName=='Zip'">
                        <mat-form-field>
                          <mat-label>Zip Code</mat-label>
                        <input class="form-control" [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight,
                        'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"  placeholder="{{field.fieldName}}" 
                        type="text"   id="{{field.id}}" placeholder="{{field.placeholder}}"
                        [(ngModel)]='field.selectedValue'  
                        (input)="onChange($event.target.value,item,field)"                    
                        (input)="searchZip($event.target.value)" 
                        [matAutocomplete]="auto"
                        matInput
                        >
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="zipselected($event,item,field.id)">
                          <mat-option *ngFor="let option of zipOption" [value]="option">
                            {{option}}
                          </mat-option>
                        </mat-autocomplete>
                        </mat-form-field>
                       </ng-container>

                       <ng-container *ngIf="field.fieldTypeName=='Location'">
                       
                    <div  id="{{field.id}}" class="customUpdate"
                    (click)="OpentoolDetail('Location')" (click)="fetchLocation(item,field.id)"
                    [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                    [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}">
                      <span *ngIf='!field.Lat && !field.Long'>
                        <mat-icon>location_on</mat-icon>
                        Location
                      </span>
                      <ng-container  *ngIf='field.Lat && field.Long'>
                      <h3 [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily}"  > 
                        Lat : {{field.Lat}}
                        Long: {{field.Long}}
                      </h3>
                     </ng-container>
                                  
                    </div>                   
                      </ng-container>  
    
                      <ng-container *ngIf="field.fieldTypeName=='Date'">
                     <div class="Dtime">
    
                     <mat-form-field>
                      <input  id="{{field.id}}" matInput type="text" [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 
                     'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily}"  
                      [ngModel]="field.selectedValue |date:'yyyy-MM-dd'" placeholder="{{field.fieldName}}"                       
                      (input)="onChange($event.target.value,item,field)" readonly
                      (dateChange)="onChange($event.target.value,item,field)"
                      (click)="OpentoolDetail('Date')"
                      (click)="OpentoolDetailText(item,field.id)"  
                     [matDatepicker]="basicDatepicker"/>
                   <mat-datepicker-toggle matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
                   <mat-datepicker #basicDatepicker ></mat-datepicker> 
                     </mat-form-field>    
                     </div>
                                 
                      </ng-container>
                   
                     <ng-container *ngIf="field.fieldTypeName=='Time'">
                    <div class="Dtime"                        
                    [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                    [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}">
                      <input id="{{field.id}}" type="text" [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                      aria-label="default time" [ngxTimepicker]="toggleTimepicker" (click)="OpentoolDetail('Time')" 
                      (click)="OpentoolDetailText(item,field.id)" matInput  placeholder="{{field.fieldName}}" [(ngModel)]='field.selectedValue' readonly>
                    <ngx-material-timepicker-toggle matSuffix [for]="toggleTimepicker"></ngx-material-timepicker-toggle>
                    <ngx-material-timepicker (timeSet)="onChange($event,item,field)"  #toggleTimepicker>
                    </ngx-material-timepicker>
                    </div>
                     </ng-container>
                  
                        
                      <ng-container *ngIf="field.fieldTypeName=='File'">
                          <div class="customUpdate" (click)="OpentoolDetail('File')"  id="{{field.id}}"
                          (click)="OpentoolDetailText(item,field.id)"
                          [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                          [ngClass]="{'ng-active' : field.ShowtoolDetail}">
                            <span id="cloud_upload" *ngIf='field.FileData.length==0'>
                              <mat-icon>cloud_upload</mat-icon>
                              Upload File
                            </span>                    
    
                            <div *ngFor="let file of field.FileData" class="uploadedData">
                              <p>{{file.FullPath}}</p>
                          </div>
                          <input type="file" class="form-control" id="{{field.fieldName}}" 
                          (change)="onSelectFile($event,item,field.id)" placeholder="{{field.fieldName}}">
                          </div>
                      </ng-container>                 
    
                        <ng-container *ngIf="field.fieldTypeName=='Signature'">
                          <div  id="{{field.id}}" class="customUpdate" 
                          [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                          [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                          (click)="OpentoolDetail('Signature')" (click)="OpenSignPopup(AddSignature,item,field)">
                            <span id="border_color" *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0'>
                              <mat-icon>border_color</mat-icon>
                              Signature
                            </span>
                            <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" /> 
                          
                            <ng-container  *ngIf='field.signatureText && !field.signatureBase64'>
                            <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}" >{{field.signatureText}}</h3>
                          </ng-container>
                            <div *ngFor="let img of field.ImageData" class="uploadedData">
                              <img [src]="img.Imageurl"  [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}"/> 
                          </div>                
                          </div>                   
                        </ng-container>  
                        
                        <ng-container *ngIf="field.fieldTypeName=='Draw'">
                          <div  id="{{field.id}}" class="customUpdate" (click)="OpentoolDetail('Draw')" 
                          (click)="OpenDrawPopup(Draw,item,field,field.id)"
                          [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                          [ngClass]="{'ng-active' : field.ShowtoolDetail}">
                            <span id="draw_brush" *ngIf='!field.drawBase64  && field.ImageData.length==0'>
                              <mat-icon>brush</mat-icon>
                              Draw
                            </span>                                  
                            <img *ngIf='field.drawBase64' [src]="field.drawBase64"  [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}"/>  
                          </div>                   
                        </ng-container>  
    
                        <ng-container *ngIf="field.fieldTypeName=='Drawpopup'">
                          <div  id="{{field.id}}" class="customUpdate" (click)="OpentoolDetail('Draw1')" (click)="OpenDrawInPopup(DrawInPopup)" >
                            <span id="draw_brush" *ngIf='!field.drawBase64  && field.ImageData.length==0'>
                              <mat-icon>brush</mat-icon>
                              Draw
                            </span>                                  
                            <img *ngIf='field.drawBase64' [src]="field.drawBase64" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}"/>  
                          </div>                   
                        </ng-container>
                      
                        <ng-container *ngIf="field.fieldTypeName=='Initials'">
                          <div  id="{{field.id}}" class="customUpdate" 
                          [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                          [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                          (click)="OpentoolDetail('Initials')" (click)="OpenSignPopup(AddInitial,item,field)">
                            <span id="initial_gesture" *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0'>
                            <mat-icon>gesture</mat-icon>
                              Initials
                            </span>
                            <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" /> 
                            <ng-container  *ngIf='field.signatureText && !field.signatureBase64' >
                              <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}" >{{field.signatureText}}</h3>
                            </ng-container>
                            <div *ngFor="let img of field.ImageData" class="uploadedData">
                              
                              <img [src]="img.Imageurl"  [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}"/> 
                          </div>                
                          </div>                   
                        </ng-container>  
                      
                        
                        <ng-container *ngIf="field.fieldTypeName=='Button'">
                          <a [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                         class="btn-primary btnGlobal"  id="{{field.id}}"
                          href="{{field.buttonURL}}" target="_blank"
                          (click)="OpentoolDetail('Button')" 
                          (click)="OpentoolDetailText(item,field.id)">{{field.buttonName}}</a>
                        </ng-container>                  
                 
              </div>
            </div>
          </ng-container>
    
          <ng-container  *ngIf="field.selectedParticipant?.groupRelationParticipantMappingID>-1 && field.fieldTypeName=='Checkbox' || field.fieldTypeName=='Radio' ||
          field.fieldTypeName=='CheckBoxGroup'">
            <div class="radioHolder"  id="{{field.id}}"  *ngIf="!field.isDisabled" >
              <div *ngFor="let ele of field.fillList; let i=index"  class="iframe-resize-container"  [attr.field]="field.id"
              
              [ngClass]="{'ng-show-required' : field.showRequiredControls}"
            
              (click)="verifyParticipant(field,$event)">
             
              <div class="iframe-drag-handle"  [attr.field]="field.id"  
            
              #dragHandle [attr.tabIndex]="setTabIndex(i,j)">
              <ng-container *ngIf="field.fieldTypeName=='Checkbox'">
                <label 
                [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                }"
                class="checkboxfield" (click)="OpentoolDetail('Checkbox')"
                (click)="OpentoolDetailCheckBox(item,field.id,ele.id)">                
                    <input type="checkbox" class="mat-checkbox-input" [checked]='ifChkCheckedAutoFill(field,item,ele.id)'
                      (click)="OnChangeCheckBox($event, ele.val, field,item,ele.id)">
                    {{ele.val}}               
                </label>
               
              </ng-container>
    
              <ng-container *ngIf="field.fieldTypeName=='Radio'">
              <div class="flexCol"  id="{{field.id}}"> 
                <label  [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                }"
                class="radiofield" (click)="OpentoolDetail('Radio')"
                (click)="OpentoolDetailRadioButtonGroup(item,field.id,ele.id)">                
                  <input type="radio" class="mat-checkbox-input" 
                  
                  [attr.Checked]="ifRadioChecked(field.id,item,ele.id)? 'checked' : null"  
                  name='{{field.id}}' [checked]='ifRadioChecked(field.id,item,ele.id)' [value]="ele.val" (change)="OnChangeRadio($event, ele.val, field.id,item,ele.id)" >
                  {{ele.val}}
                </label>                  
                
              </div>
            
              </ng-container>
    
              <ng-container *ngIf="field.fieldTypeName=='CheckBoxGroup'">
                <div class="flexCol"  id="{{field.id}}">
                <label [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                class="checkboxfield" (click)="OpentoolDetail('CheckBoxGroup')"
                (click)="OpentoolDetailCheckBoxGroup(item,field.id,ele.id)">                   
                  
                  <input class="mat-checkbox-input" type="checkbox"        
                    [attr.checked]="ifChkChecked(field.id,item,ele.id)? 'checked' : null" [checked]='ifChkChecked(field.id,item,ele.id)' (change)="OnChangeCheckBoxGroup($event, ele.val, field.id,item,ele.id)">
                  {{ele.val}}
                </label>       
                </div>
              </ng-container>
    
            </div>
          </div>
          </div>
          </ng-container>
    
    
          <ng-container  *ngIf="field.selectedParticipant?.groupRelationParticipantMappingID>-1 && field.fieldTypeName=='Image'">
          <div class="radioHolder"  id="{{field.id}}"  *ngIf="!field.isDisabled">
            <div *ngFor="let ele of field.fillList; let i=index"  class="iframe-resize-container"  [attr.field]="field.id"
            [ngClass]="{'fileControl' :field.fieldTypeName=='Image'}" 
            [ngStyle]="{'height': field.Imageheight, 'width': field.Imagewidth}" 
            style="position: absolute"  
            (click)="verifyParticipant(field,$event)">
            <div class="iframe-drag-handle" (click)="addActiveClass(field)"  [attr.field]="field.id" 
            [attr.tabIndex]="setTabIndex(i,j)"  [ngClass]="{'ng-active' : field.ShowtoolDetail}"
            #dragHandle>
    
            <ng-container *ngIf="field.fieldTypeName=='Image'">
              <div class="customUpdate" (click)="OpentoolDetail('Image')"  id="{{field.id}}"
              (click)="OpentoolDetailText(item,field.id)"
              [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
              
              [ngClass]="{'ng-active' : field.ShowtoolDetail}"
              [ngClass]="{'ng-show-required' : field.showRequiredControls}">
                <span id="cloud_upload" *ngIf='field.ImageData.length==0'>
                  <mat-icon>cloud_upload</mat-icon>
                  Upload Image
                </span>
                <div *ngFor="let img of field.ImageData" class="uploadedData">
                  <img *ngIf='img.Imageurl' [src]="img.Imageurl" [ngStyle]="{'height': field.Imageheight, 'width': field.Imagewidth}"/> 
              </div>                  
                                
              <input type="file" class="form-control" accept="image/*" id="{{field.fieldName}}" 
              (change)="onSelectImage($event,item,field.id)" placeholder="{{field.fieldName}}">
              </div>                   
            </ng-container> 
    
            
                </div>
              </div>
            </div>
            </ng-container>
    
          
          </ng-container>
        </div> 
        
      </mat-expansion-panel>
 
    </mat-accordion>
    
     
  </mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button (click)="cancelFillForm()">Cancel</button>
  <button mat-flat-button color="primary" (click)="close()">Done</button>
</mat-dialog-actions>
</ng-template>

<ng-template #assignAnother>
  <h2 mat-dialog-title>
      <span class="groupIcon"><mat-icon>how_to_reg</mat-icon></span>
      Select Participant
        <button mat-icon-button (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </h2>
  
<mat-dialog-content class="mat-typography">
  
  <mat-form-field >
    <mat-label>Enter email </mat-label>
    <input matInput>
  </mat-form-field>

  <div class="d-flex">
    <mat-form-field >
      <mat-label>First Name</mat-label>
      <input matInput>
    </mat-form-field>
    <mat-form-field >
      <mat-label>Last Name</mat-label>
      <input matInput>
    </mat-form-field>
  </div>

  <mat-form-field>
    <mat-label>Message </mat-label>
    <textarea matInput class="txtarea" placeholder="Write a message..." ></textarea>
  </mat-form-field>

</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary">Add</button>
</mat-dialog-actions>
</ng-template>

<ng-template #acceptFinish>
  <h2 mat-dialog-title>
      <span class="groupIcon" ><mat-icon>how_to_reg</mat-icon></span>
      Signature Acceptance
        <button mat-icon-button (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </h2>
  
<mat-dialog-content class="mat-typography">
  
  <h3>I am accepting that signing esignature is valid and I am responsible for all authorized work with this signature in flowtrics. </h3>

</mat-dialog-content>
<mat-dialog-actions >
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" [disabled]='isAcceptButtonDisabled'  (click)="AcceptBtnClick(true)" >Accept</button>
</mat-dialog-actions> 
</ng-template>

<ng-template #OtherFieldAssigned>
  <h2 mat-dialog-title>
      <span class="groupIcon" ><mat-icon>how_to_reg</mat-icon></span>
      Additional Fields
        <button mat-icon-button (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </h2>
  
<mat-dialog-content class="mat-typography">
  
  <h3>Additional Fields are left to fill in following documents, do you want to submit form?</h3>
 <h4 *ngFor="let d of docstoFill;index as i">{{i+1}}.{{d.name}}</h4>
</mat-dialog-content>
<mat-dialog-actions >
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" [disabled]='isAcceptButtonDisabled'  (click)="SignatureAcceptanceFInal(acceptFinish)" >Proceed</button>
</mat-dialog-actions> 
</ng-template>

<ng-template #requiredFieldAssigned>
  <h2 mat-dialog-title>
      <span class="groupIcon" ><mat-icon>how_to_reg</mat-icon></span>
      Required Fields
        <button mat-icon-button (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </h2>
  
<mat-dialog-content class="mat-typography">
  
  <h3>Please fill required fields in following documents.</h3>
 <h4 *ngFor="let d of docstoFill;index as i">{{i+1}}.{{d.name}}</h4>
</mat-dialog-content>
<mat-dialog-actions >
  <button mat-flat-button color="primary" (click)="close()" >OK</button>
</mat-dialog-actions> 
</ng-template>

<ng-template #AddSignature>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>create</mat-icon>
    </span>
    Add Signature
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="tabConainer">
     
      <div class="radOpts">
        <mat-radio-group aria-label="Select an option" color="primary"  [(ngModel)]="signOpt">
            <mat-radio-button value="draw" (change)="radioChangeSign()">Draw</mat-radio-button>
            <mat-radio-button value="upload" (change)="radioChangeSign()">Upload</mat-radio-button>
            <mat-radio-button value="type" (change)="radioChangeSign()">Type In</mat-radio-button>
          </mat-radio-group>
    </div>
     


        <div class="allSCont">
          <ng-container *ngIf="signOpt == 'upload'">
            <div class="uploadholder">
              <mat-icon>note_add</mat-icon>
              <p *ngIf="filenameForSign == '' ">Drop your signature here or click here to upload</p>
              <span  *ngIf="filenameForSign == '' ">File extension should be .png</span>
              <p>{{filenameForSign}}</p>
              <input type="file" class="form-control" accept="image/*" 
              (change)="onSelectSignImage($event,'','')" placeholder="Add file">
            </div>
          </ng-container>
          
            <ng-container *ngIf="signOpt == 'draw'">
              <signature-pad [options]="signaturePadOptions"   (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete()"></signature-pad>
            </ng-container>
          
            <ng-container *ngIf="signOpt == 'type'">
              <div class="divideCol">
                <div class="left blk">
                  <mat-form-field >
                    <mat-label>Enter Name</mat-label>
                    <input matInput required placeholder="Enter name" value="" [(ngModel)]="signName" (ngModelChange)="signOrInitialTextChanges($event)">
                  </mat-form-field>
                </div>
                <div class="right blk">
                  <mat-form-field appearance="fill">
                      <mat-label>Select font family</mat-label>
                      <mat-select [(value)]="selected" (selectionChange)="setSignInitialFontFamilyChange($event.value)">
                        <mat-option *ngFor="let fam of family; index as i" value="{{fam.font}}" >{{fam.font}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                </div>
              </div>
              <div class="allSign">
                <div class="signlook" [ngStyle]="{'font-family': signInitialFontFamily }">
                  {{signName}}
                </div>
                <style>@import 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap';</style>
              </div>
            </ng-container>
         </div>
  </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <span>
      <button *ngIf="signOpt == 'draw'" mat-stroked-button color="primary" (click)="clearSignature()" >Clear</button>
      <button mat-flat-button  (click)="addSignature()"  color="primary" [disabled]="!SignButtonEnable">Sign</button>
    </span>
  </mat-dialog-actions>
</ng-template>

<ng-template #Draw>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>brush</mat-icon>
    </span>
    Draw
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="tabConainer">    
        <div class="allSCont">
            <ng-container>
              <signature-pad id="drawCanvas" [options]="signaturePadOptions" (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete()"></signature-pad>
            </ng-container>           
         </div>
  </div>
  </mat-dialog-content>
  <mat-dialog-actions >
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button (click)="addDrawnImg()" [disabled]="!DrawButtonEnable" color="primary">Save</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #DrawInPopup>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>brush</mat-icon>
    </span>
    Draw
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="tabConainer">
      <div class="allSCont">  
          
            <ng-container>
              <!-- <signature-pad id="drawCanvas" [options]="signaturePadOptions" (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete()"></signature-pad> -->
              <image-drawing
              [width]="500" [height]="500"
              borderCss="1px solid black"
              [showCancelButton]="false"
              [enableLoadAnotherImage]="true" [enableRemoveImage]="true"
              [src]="ControlData.img"
              (save)="saveBtn($event)"
              [i18n]="i18n"
              [locale]="'en'"
              [drawingSizes]="{small:5,medium:10,large:25,extra:50}"
              ></image-drawing>
            </ng-container>
          
           
         </div>
  </div>
  </mat-dialog-content>
  <mat-dialog-actions >
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button (click)="addDrawnImg()"  color="primary">Save</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #AddInitial>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>gesture</mat-icon>
    </span>
    Add Initials
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="tabConainer">
      <div class="radOpts">
        <mat-radio-group aria-label="Select an option" color="primary"  [(ngModel)]="signOpt">
            <mat-radio-button value="draw" (change)="radioChangeInitails()">Draw</mat-radio-button>
            <mat-radio-button value="upload" (change)="radioChangeInitails()">Upload</mat-radio-button>
            <mat-radio-button value="type" (change)="radioChangeInitails()">Type In</mat-radio-button>
          </mat-radio-group>
    </div>
      


        <div class="allSCont">
          <ng-container *ngIf="signOpt == 'upload'">
            <div class="uploadholder">
              <mat-icon>note_add</mat-icon>
              <p>Drop your initials here or click here to upload</p>
              <span>File extension should be .png</span>
              <input type="file" class="form-control" accept="image/*" 
              (change)="onSelectSignImage($event,'','')" placeholder="Add file">
            </div>
          </ng-container>
          
            <ng-container *ngIf="signOpt == 'draw'">
              <signature-pad [options]="signaturePadOptions" (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete()"></signature-pad>
            </ng-container>
          
            <ng-container *ngIf="signOpt == 'type'">
              <div class="divideCol">
                <div class="left blk">
                  <mat-form-field >
                    <mat-label>Enter Name</mat-label>
                    <input matInput required placeholder="Enter name" value="" [(ngModel)]="signName" (ngModelChange)="signOrInitialTextChanges($event)">
                  </mat-form-field>
                </div>
                <div class="right blk">
                  <mat-form-field appearance="fill">
                      <mat-label>Select font family</mat-label>
                      <mat-select [(value)]="selected" (selectionChange)="setSignInitialFontFamilyChange($event.value)">
                        <mat-option *ngFor="let fam of family; index as i" value="{{fam.font}}" >{{fam.font}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                </div>
              </div>
              <div class="allSign">
                <div class="signlook" [ngStyle]="{'font-family': selected}" >
                  {{signName}}
                </div>
              </div>
            </ng-container>
         </div>
  </div>
  </mat-dialog-content>
  <mat-dialog-actions >
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button (click)="addSignature()"  [disabled]="!InitailButtonEnable" color="primary">Sign</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #addAssigne>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>group_add</mat-icon>
    </span>
    Select & Add Participant

    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="searchBY">
      <mat-radio-group aria-label="Select an option" color="primary">
        <mat-radio-button value="1">By Name</mat-radio-button>
        <mat-radio-button value="2">By Email</mat-radio-button>
        <mat-radio-button value="3">By Role</mat-radio-button>
      </mat-radio-group>
    </div>

    <app-contactlist></app-contactlist>    
 
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary">Done</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #Newfolder>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>create_new_folder</mat-icon>
    </span>
    Folder Name
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <form class="fillformOpt">
      <mat-form-field class="example-full-width">
        <mat-label>Folder Name</mat-label>
        <input matInput placeholder="Enter Folder Name" value="" />
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions >
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary">Create</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #docPreview>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>preview</mat-icon>
    </span>
    Document Preview
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">

    <embed class="openpdf" src="../../../../assets/Residential_Lease.pdf">

  </mat-dialog-content>
  <mat-dialog-actions >
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary">Done</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #relation>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>group_add</mat-icon>
    </span>
    Add Relations Under Group 1
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">

    <app-contactlist></app-contactlist>

    <ul class="selectedlist">
      <li>
        <div class="userndetail">
          <div class="detail">
            <h4>Doctor</h4>
          </div>
          <div class="opt">
            <button mat-icon-button>
              <mat-icon>cancel</mat-icon>
            </button>
          </div>
        </div>
      </li>
      <li>
        <div class="userndetail">
          <div class="detail">
            <h4>Nurse</h4>
          </div>
          <div class="opt">
            <button mat-icon-button>
              <mat-icon>cancel</mat-icon>
            </button>
          </div>
        </div>
      </li>
    </ul>

  </mat-dialog-content>
  <mat-dialog-actions >
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary">Done</button>
  </mat-dialog-actions>
</ng-template> 

<app-loader></app-loader>

<!-- <div class="progress-loader" *ngIf="spinner">  
  <div class="loader">
      <div class="loader__bar"></div>
      <div class="loader__bar"></div>
      <div class="loader__bar"></div>
      <div class="loader__bar"></div>
      <div class="loader__bar"></div>
      <div class="loader__ball"></div>
    </div>

</div> -->

<div class="progress-loader" *ngIf="spinner">

  <div class="lds-ripple" ><div></div><div></div></div>
</div>

<ng-template #decline>
  <h2 mat-dialog-title>
      <span class="groupIcon" ><mat-icon>thumb_down_off_alt</mat-icon></span>
      Decline Form
        <button mat-icon-button (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </h2>
  
<mat-dialog-content class="mat-typography"> 

  <mat-form-field>
    <mat-label>Please add reason for decline </mat-label>
    <textarea matInput [(ngModel)]="reasonToDecline" class="txtarea" placeholder="Write a reason..." 
    (keypress)="keyPress($event)"></textarea>
  </mat-form-field>

</mat-dialog-content>
<mat-dialog-actions >
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary"  [disabled]="!declineButtonShow"  (click)="declineForm()">Decline</button>
</mat-dialog-actions>
</ng-template>







